import { work1, work2, work3, work4, workImg } from "../../assets/img";
import heroBg from "../../assets/img/laundryup/hero-bg.jpg";
export const data = {
  home: {
    sections: [
      {
        _id: 1,
        is_section_enable: true,
        icon: "/assets/section/section1.jpg",
      },
      {
        _id: 2,
        is_section_enable: true,
        icon: "/assets/section/section2.jpg",
      },
      {
        _id: 3,
        is_section_enable: true,
        icon: "/assets/section/section3.jpg",
      },
      {
        _id: 4,
        is_section_enable: true,
        icon: "/assets/section/section4.jpg",
      },
      {
        _id: 5,
        is_section_enable: true,
        icon: "/assets/section/section5.jpg",
      },
      {
        _id: 6,
        is_section_enable: true,
        icon: "/assets/section/section6.jpg",
      },
      {
        _id: 7,
        is_section_enable: true,
        icon: "/assets/section/section7.jpg",
      },
      {
        _id: 8,
        is_section_enable: true,
        icon: "/assets/section/section8.jpg",
      },
      {
        _id: 9,
        is_section_enable: true,
        icon: "/assets/section/section9.jpg",
      },
      {
        _id: 10,
        is_section_enable: true,
        icon: "/assets/section/section10.jpg",
      },
      {
        _id: 11,
        is_section_enable: true,
        icon: "/assets/section/section11.jpg",
      },
      {
        _id: 12,
        is_section_enable: true,
        icon: "/assets/section/section12.jpg",
      },
      {
        _id: 13,
        is_section_enable: true,
        icon: "/assets/section/section13.jpg",
      },
      {
        _id: 15,
        is_section_enable: true,
        icon: "/assets/section/section15.jpg",
      },
    ],
    header: {
      is_section_enable: true,
      primary_color: "1B9DB3",
      secondary_color: "F07F1B",
      nav: {
        bg_color: "ffffff",
        menu_font_color: "2e3639",
        menu_font_color_active: "1b9db3",
        menu_font_color_hover: "f07f1b",
        cart_section: {
          is_enable: true,
          bg_color: "ffffff",
          cart_icon_color: "ffffff",
          cart_icon_bg_color: "#f07f1b",
          cart_label_section: {
            label: "items : ",
            color: "#6b7385",
          },
          cart_value_color: "000000",
        },
      },
      btn_group: {
        btn1: {
          text: "Login / Register",
          bg_color: "ffffff",
          color: "#1b9db3",
          border_color: "#1b9db3",
          btn1_is_enable: true,
        },
        btn2: {
          text: "Quick Order",
          color: "ffffff",
          bg_color: "000",
          border_color: "#192335",
          btn2_is_enable: true,
        },
      },
    },
    section_1: {
      is_section_enable: true,
      banner: "/assets/home_page_single_search.jpg",
      sub_heading_top: "24/7 Dry Cleaning & Laundry Service",
      title: "One Solution for all your Washing Needs",
      paragraph:
        "Bestatlaundry is synonymous with quality, reliability, and trust. We provide fast dry cleaning and laundry services in and around London. Advance online technology and modern process and equipment utilization means affordable cost to all our customers.",
      btn_group: {
        btn1: {
          text: "Book now",
          bg_color: "#1b9db3",
          color: "ffffff",
          placeholder: "Enter Postalcode",
        },
      },
      mobile_link_section: {
        is_enable: true,
        mob_title: "Just A Click Away",
        android_link: "#",
        ios_link: "#",
      },
    },
    section_2: {
      is_section_enable: true,
      sub_heading_top: "Book A Service",
      title: "Select Your Time & Location For The Service",
      btn_group: {
        btn1: {
          text: "order now",
          bg_color: "#1b9db3",
          color: "ffffff",
          placeholder: "Enter Postcode",
        },
      },
    },
    section_3: {
      is_section_enable: true,
      title: "Trust the Experts",
      paragraph:
        "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC",
      card_section: {
        collection: [
          {
            _id: 1,
            icon: "/assets/icons/priorityicon1.png",
            collection_title: "Top Quality",
            collection_paragraph:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
          },
          {
            _id: 2,
            icon: "/assets/icons/priorityicon2.png",
            collection_title: "Best Service",
            collection_paragraph:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
          },
          {
            _id: 3,
            icon: "/assets/icons/priorityicon3.png",
            collection_title: "Value",
            collection_paragraph:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
          },
          {
            _id: 4,
            icon: "/assets/icons/priorityicon4.png",
            collection_title: "Professionalism",
            collection_paragraph:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
          },
          {
            _id: 5,
            icon: "/assets/icons/priorityicon5.png",
            collection_title: "Convenience",
            collection_paragraph:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
          },
          {
            _id: 6,
            icon: "/assets/icons/priorityicon6.png",
            collection_title: "Cleanliness",
            collection_paragraph:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
          },
        ],
        btn_group: {
          btn1: {
            text: "More About Us",
            bg_color: "192335",
            color: "ffffff",
          },
        },
      },
    },
    section_4: {
      is_section_enable: true,
      title:
        "Bestatlaundry is Ranked #1 by customers in the UK in categories of dry cleaning",
    },
    section_5: {
      is_section_enable: true,
      banner: [
        {
          banner: "/assets/home/howwe1.jpg",
        },
      ],
      title: "We collect, clean, & deliver your laundry & dry cleaning.",
      paragraph:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
      check_list: [
        {
          _id: 1,
          title: "Free same day collection",
        },
        {
          _id: 1,
          title: "24h turnaround time",
        },
        {
          _id: 1,
          title: "Dedicated 24/7 support",
        },
        {
          _id: 1,
          title: "Standard wash for just £14",
        },
        {
          _id: 1,
          title: "Wash & Fold for items that don't need pressing",
        },
        {
          _id: 1,
          title: "Free collection and delivery",
        },
      ],
      btn_group: {
        btn1: {
          text: "Schedule a Collection Now",
          bg_color: "#192335",
          color: "ffffff",
          is_enable: true,
        },
        btn2: {
          text: "Request a Pickup",
          bg_color: "#1b9db3",
          color: "ffffff",
          is_enable: true,
        },
      },
    },
    section_6: {
      is_section_enable: true,
      sub_heading_top: "Know More On",
      title: "How We Works",
      paragraph: "We collect, clean and deliver your clothes within 24-48 hrs.",
      card_section: {
        collection: [
          {
            _id: 1,
            icon: "/assets/home/howwe1.jpg",
            card_title: "Online Order",
            card_paragraph:
              "Use our friendly and easy access website or app to place your laundry order. choose a suitable pickup location and time.",
          },
          {
            _id: 2,
            icon: "/assets/home/howwe2.jpg",
            card_title: "Transport",
            card_paragraph:
              "Our registered driver will pick up your laundry at your doorstep and transport the laundry safely to one of our many trusted dry cleaning facilities.",
          },
          {
            _id: 3,
            icon: "/assets/home/howwe3.jpg",
            card_title: "Dry Cleaning",
            card_paragraph:
              "Our registered driver will pick up your laundry at your doorstep and transport the laundry safely to one of our many trusted dry cleaning facilities.",
          },
          {
            _id: 4,
            icon: "/assets/home/howwe4.jpg",
            card_title: "Door Delivery",
            card_paragraph:
              "Dry and clean clothes were carefully bagged and delivered to your doorstep.",
          },
        ],
        btn_group: {
          paragraph: "Lorem Ipsum is simply dummy text of the",
          btn1: {
            text: "Book Online Now",
            bg_color: "#192335",
            color: "#ffffff",
          },
        },
      },
    },
    section_7: {
      is_section_enable: true,
      title: "On Demand Laundry, Dry Cleaning And Ironing Categories",
      paragraph:
        "We provide commercial laundry, shoe repair, clothing alteration, tailoring and wedding dress fitting services in London, Essex, Kent, Westminster, Chelsea, Dartford, Croydon, Enfield, Basildon, South On Sea, Bromley, Mayfair, Romford and other areas in London.",
      btn_group: {
        btn_paragraph: "Lorem Ipsum is simply dummy text of the",
        btn1: {
          text: " Request a Pickup",
          bg_color: "192335",
          color: "fff",
        },
      },
    },
    section_8: {
      is_section_enable: true,
      banner: "howwe1",
      title: "About Us",
      section_image: "/assets/home/trustimg2.jpg",
      paragraph:
        "Bestatlaundry is synonymous with quality, reliability, and trust. We provide fast dry cleaning and laundry services in and around London. Advance online technology and modern process and equipment utilization means affordable cost to all our customers.",
      card_section: {
        collection: [
          {
            _id: 1,
            icon: "James please use React import aliase",
            collection_title: "Free Pick up and Delivery",
            collection_image: "/assets/icons/priorityicon7.png",
            isEnabled: true,
            collection_paragraph:
              "We offer a convenient way to have laundry picked up and delivered for free.",
          },
          {
            _id: 2,
            icon: "James please use React import aliase",
            collection_title: "High Quality of Services",
            collection_image: "/assets/icons/priorityicon8.png",
            isEnabled: true,
            collection_paragraph:
              "Our laundry team perfectly cleans, iron, fold, pack, and deliver to you on time.",
          },
          {
            _id: 3,
            icon: "James please use React import aliase",
            collection_title: "Affordable Cost",
            collection_image: "/assets/icons/priorityicon9.png",
            isEnabled: true,
            collection_paragraph:
              "We offer affordable prices when compared to the current market.",
          },
        ],
      },
      btn_group: {
        btn1_text: "Schedule a Collection Now",
        btn1_bg_color: "192335",
        btn1_color: "ffffff",
        btn2_text: "Request a Pickup",
        btn2_bg_color: "1b9db3",
        btn2_color: "ffffff",
      },
    },
    section_9: {
      is_section_enable: true,
      section_bg_color: "#1b9db3",
      sub_heading_top: "Our Promising Services",
      title: "On Demand Laundry, Dry Cleaning And Ironing Service",
      paragraph: "We collect, clean and deliver your clothes within 24-48 hrs.",
      card_section: {
        collection: [
          {
            _id: 1,
            icon: "/assets/home/priorityimg1.jpg",
            collection_title: "Laundry",
            collection_paragraph:
              "A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.",
          },
          {
            _id: 2,
            icon: "/assets/home/priorityimg2.jpg",
            collection_title: "Dry Cleaning",
            collection_paragraph:
              "A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.",
          },
          {
            _id: 3,
            icon: "/assets/home/priorityimg3.jpg",
            collection_title: "Alteration & Repair",
            collection_paragraph:
              "A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.",
          },
          {
            _id: 14,
            icon: "/assets/home/priorityimg1.jpg",
            collection_title: "Laundry",
            collection_paragraph:
              "A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.",
          },
        ],
        count_section: [
          {
            _id: 1,
            icon: "/assets/icons/priorityicon1.png",
            text: "Laundry Clothes",
            count: "1639+",
          },
          {
            _id: 2,
            icon: "/assets/icons/priorityicon2.png",
            text: "Steam Ironing",
            count: "24359+",
          },
          {
            _id: 3,
            icon: "/assets/icons/priorityicon3.png",
            text: "Dry Cleaning",
            count: "4793+",
          },
          {
            _id: 4,
            icon: "/assets/icons/priorityicon4.png",
            text: "Cleaning programs",
            count: "25+",
          },
        ],
      },
    },
    section_10: {
      is_section_enable: true,
      banner: "/assets/home/trustimg3.png",
      sub_heading_top: "Your Health & Safety Is Our Priority",
      title: "Our Values",
      mainparagraph:
        "online laundry & dry cleaning companies who simply just own the technology and farm the cleaning to other providers with little to no process system checks.",
      list_Section: [
        {
          _id: 1,
          text: "Contactless deliveries",
          paragraph:
            "For our customers safety, we enabled the feature to allow customers to conduct contactless pick up & deliveries.",
        },
        {
          _id: 2,
          text: "Instant updates",
          paragraph:
            "We’ll keep you posted throughout the process with texts/emails when driver is on their way and order has been cleaned.",
        },
        {
          _id: 3,
          text: "Monitoring the situation",
          paragraph:
            "We’re keeping up to date with all developments from government to ensure the safety of our customers and staff.",
        },
      ],
      card_section_title: "We use Eco-friendly Laundry Detergent Sheets.",
      card_section: [
        {
          _id: 1,
          card_bg_color: "192335",
          card_text: "Vegan",
          card_paragraph:
            "Our vegan-friendly laundry detergent is free from any animal product.",
        },
        {
          _id: 2,
          card_bg_color: "f07f1b",
          card_text: "Cruelty Free",
          card_paragraph:
            "We never test on animals – so our Laundry Leaves will always be cruelty-free.",
        },
        {
          _id: 3,
          card_bg_color: "1bb333",
          card_text: "Eco-Friendly",
          card_paragraph:
            "Free from any harmful chemicals or pollutants and are devoid of harmful toxins.",
        },
      ],
    },
    section_11: {
      is_section_enable: true,
      banner: [
        {
          banner: "/assets/home/howwe1.jpg",
        },
      ],
      card_section: {
        collection: [
          {
            _id: 1,
            collection_title: "Free Pick up and Delivery",
            isEnabled: true,
            collection_paragraph:
              "We offer a convenient way to have laundry picked up and delivered for free.",
          },
          {
            _id: 2,
            collection_title: "High Quality of Services",
            isEnabled: true,
            collection_paragraph:
              "Our laundry team perfectly cleans, iron, fold, pack, and deliver to you on time.",
          },
          {
            _id: 3,
            collection_title: "Affordable Cost",
            isEnabled: true,
            collection_paragraph:
              "We offer affordable prices when compared to the current market.",
          },
        ],
      },
      sub_heading_top: "Ask Your Question",
      title: "Frequently Asked Questions",
      paragraph:
        "online laundry & dry cleaning companies who simply just own the technology and farm the cleaning to other providers with little to no process system checks.",
    },
    section_12: {
      is_section_enable: true,
      banner: "howwe1",
      sub_heading_top: "What Our Client Says",
      title: "A Trusted Laundry And Dry Cleaning Company",
      paragraph: "Read what our customers say about us",
      review_bottom_paragraph:
        "More than 5,000+ reviews s on TrustPilot, Google, Google Play & App Store",
      review_card: [
        {
          _id: 1,
          reviewer_pic: "/assets/home/testimonialuser1.jpg",
          reviewer_name: "Ariyan Rusov",
          rating: "5",
          review_highlight: "Finibus mauris. Aliquam consectetur",
          review:
            "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
        },
        {
          _id: 2,
          reviewer_pic: "/assets/home/testimonialuser2.jpg",
          reviewer_name: "Darren Valdez",
          rating: "4",
          review_highlight: "Finibus mauris. Aliquam consectetur",
          review:
            "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
        },
        {
          _id: 3,
          reviewer_pic: "/assets/home/testimonialuser3.jpg",
          reviewer_name: "Elinor Dunn",
          rating: "5",
          review_highlight: "Finibus mauris. Aliquam consectetur",
          review:
            "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
        },
      ],
      btn_group: {
        btn1: {
          text: "Book Online Now",
          bg_color: "#192335",
          color: "#ffffff",
          is_enable: true,
        },
      },
    },
    section_13: {
      is_section_enable: true,
      banner: "howwe1",
      title: "Just A Click Away",
      paragraph: "Download Our Best Active Mobile App",
      check_list: [
        {
          _id: 1,
          icons: "/assets/icons/priorityicon14.png",
          title: "Cashless payments",
        },
        {
          _id: 2,
          icons: "/assets/icons/priorityicon15.png",
          title: "Delivery in less then 24 hours",
        },
        {
          _id: 3,
          icons: "/assets/icons/priorityicon16.png",
          title: "Standard wash for just £14",
        },
        {
          _id: 4,
          icons: "/assets/icons/priorityicon17.png",
          title: "In-app live chat support",
        },
      ],
      mobile_link_section: {
        is_enable: true,
        android_link:
          "https://play.google.com/store/apps/details?id=co.in.dreamguys.bestatlaundry",
        ios_link:
          "https://itunes.apple.com/us/app/best-laundry/id1434880614?ls=1&mt=8",
      },
    },
    section_14: {
      is_section_enable: true,
      section_bg_color: "#1b9db3",
      title:
        "Subscribe to our newsletter for updates, exclusive promotions and our latest content!",
      btn_group: {
        btn1: {
          text: "Subscribe",
          bg_color: "#192335",
          color: "ffffff",
        },
      },
    },
    section_15: {
      is_section_enable: true,
      sub_heading_top: "Our Latest",
      title: "News & Events",
      paragraph:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
      btn_group: {
        btn1: {
          text: "More News & Events",
          bg_color: "#192335",
          color: "ffffff",
        },
      },
    },
    footer: {
      custome_banner_design: {
        is_enable: true,
      },
      bg_color: "151e2e",
      section_heading_color: "ffffff",
      section_paragraph_color: "c2c2c2",
      footer_section: {
        about_section: {
          is_enable: true,
          text: "Ready to take laundry off your to-do list? Bestatlaundry services is a local laundry pickup and delivery service that you can order directly from your smart phone.",
        },
        service_section: {
          is_enable: true,
        },
        quicklink_section: {
          is_enable: true,
        },
        callnow_for_Services_section: {
          is_enable: true,
          mbl_no: {
            label: "+442086388690",
            value: "tel:+442086388690",
          },
          email: {
            label: "Email Us",
            value: "sales@bestatlaundry.com",
          },
          address: {
            text: "81 Randall Drive, Hornchurch - RM126TA",
          },
        },
        social_media: {
          facebook: {
            is_enable: true,
            facebook_link: "facebook.com",
          },
          instagram: {
            is_enable: true,
            instagram_link: "instagram.com",
          },
          whatsapp: {
            is_enable: true,
            whatsapp_link: "whatsapp.com",
          },
          linkedin: {
            is_enable: true,
            linkedin_link: "linkedin.com",
          },
          youtube: {
            is_enable: true,
            youtube_link: "youtube.com",
          },
          twitter: {
            is_enable: true,
            twitter_link: "twitter.com",
          },
        },
      },
    },
  },
  theme_1: {
    home: {
      sections: [
        {
          _id: 1,
          is_section_enable: true,
          icon: "/assets/img/section/section1.png",
        },
        {
          _id: 3,
          is_section_enable: true,
          icon: "/assets/img/section/section3.png",
        },
        {
          _id: 4,
          is_section_enable: true,
          icon: "/assets/img/section/section4.png",
        },
        {
          _id: 5,
          is_section_enable: true,
          icon: "/assets/img/section/section5.png",
        },
        {
          _id: 6,
          is_section_enable: true,
          icon: "/assets/img/section/section6.png",
        },
        {
          _id: 7,
          is_section_enable: true,
          icon: "/assets/img/section/section7.png",
        },
        {
          _id: 8,
          is_section_enable: true,
          icon: "/assets/img/section/section8.png",
        },
        {
          _id: 9,
          is_section_enable: true,
          icon: "/assets/img/section/section9.png",
        },
        {
          _id: 10,
          is_section_enable: true,
          icon: "/assets/img/section/section10.png",
        },
      ],
      header: {
        primary_color: "ff0059",
        secondary_color: "ffcb00",
        nav: {
          nav_bg_color: "ffffff",
          menu_font_color: "2e3639",
          menu_font_color_active: "1b9db3",
          menu_font_color_hover: "f07f1b",
          cart_section: {
            cart_bg_color: "ffffff",
            cart_icon_bg_color: "f07f1b",
            cart_value_color: "000000",
          },
          contact: {
            contact_is_enable: true,
            number: "+(044) 071012345",
            contact_color: "2e3639",
          },
        },
        btn_group: {
          btn1: {
            text: "Login / Register",
            btn_bg_color: "ffffff",
            btn_color: "1b9db3",
            border_color: "1b9db3",
            btn1_is_enable: true,
          },
        },
      },
      section_1: {
        banner: "/assets/img/home_page_single_search.jpg",
        sub_heading_top: "24/7 Dry Cleaning & Laundry Service",
        title: "One Solution for all your Washing Needs",
        paragraph:
          "While you are doing something important, we will put things in order in the apartment, private house or office, clean the upholstered furniture and wash the windows.",
        btn_group: {
          btn1: {
            text: "Book now",
            placeholder: "Enter Postalcode",
            bg_color: "1b9db3",
            color: "ffffff",
          },
        },
      },
      section_2: {
        title: "Select Your Time & Location For The Service",
        btn_group: {
          btn1: {
            text: "order now",
            placeholder: "Enter Postcode",
            bg_color: "1b9db3",
            color: "ffffff",
          },
        },
      },
      section_3: {
        is_section_enable: true,
        banner: "/assets/img/trustimg.png",
        title: "Trust the Expert",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        paragraph:
          "The aim of our company has always been to provide 5-star premium dry cleaning and laundry services to expat and local populations of the United Kingdom",
        sub_heading: "Unique solutions for all your laundry needs",
        check_list: [
          {
            _id: 1,
            list: "Clean for professional garment care",
          },
          {
            _id: 2,
            list: "Wash & Fold for items that don't need pressing",
          },
          {
            _id: 3,
            list: "Press Only for clean clothes that need pressing",
          },
          {
            _id: 4,
            list: "ShoeCare for cleaned and restored shoes",
          },
        ],
        btn_group: {
          btn1: {
            text: "Read More",
            bg_color: "#ffcb00",
            color: "ffffff",
            is_enable: true,
          },
        },
      },
      section_4: {
        title: "Your Health & Safety Is Our Priority",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        cards: [
          {
            heading: "Contactless deliveries",
            icon: "/assets/img/icons/priorityicon1.svg",
            image: "/assets/img/home/priorityimg1.jpg",
            paragraph:
              "For our customers safety, we enabled the feature to allow customers to conduct contactless pick up & deliveries.",
          },
          {
            heading: "Monitoring the situation",
            icon: "/assets/img/icons/priorityicon2.svg",
            image: "/assets/img/home/priorityimg2.jpg",
            paragraph:
              "We’re keeping up to date with all developments from government to ensure the safety of our customers and staff.",
          },
          {
            heading: "Instant updates",
            icon: "/assets/img/icons/priorityicon3.svg",
            image: "/assets/img/home/priorityimg3.jpg",
            paragraph:
              "We’ll keep you posted throughout the process with texts/emails when driver is on their way and order has been cleaned.",
          },
        ],
      },
      section_5: {
        is_section_enable: true,
        banner: "/assets/img/phone.png",
        title: "Just A Click Away",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        paragraph:
          "Our apps got a better and convenient way of getting your laundry and dry cleaning with our 5-star services. Download now and register to get more exclusive offers",
        check_list: [
          {
            _id: 1,
            icons: "/assets/img/icons/priorityicon1.svg",
            title: "Users",
            count: "25000",
          },
          {
            _id: 2,
            icons: "/assets/img/icons/priorityicon2.svg",
            title: "Downloads",
            count: "40000",
          },
          {
            _id: 3,
            icons: "/assets/img/icons/priorityicon3.svg",
            title: "Ratings",
            count: "4.5",
          },
        ],
        mobile_link_section: {
          is_enable: true,
          android_link:
            "https://play.google.com/store/apps/details?id=co.in.dreamguys.bestatlaundry",
          ios_link:
            "https://itunes.apple.com/us/app/best-laundry/id1434880614?ls=1&mt=8",
        },
      },
      section_6: {
        heading: "Save with Our Subscriptions",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        card_one_title: "Laundry Bag",
        card_one_paragraph:
          "One bag = one price, fill it up and get it washed! Includes FREE next day delivery & all perks from Laundry Go. Ideal for couples & families. Plans start from £25/month",
        card_one_image: "/assets/img/home/wing1.png",
        card_two_title: "Ongoing discount on All Services",
        card_two_paragraph:
          "10% OFF all services (apart from laundry) for just £3.99/month. This includes Eco Dry Cleaning, shirt service & bed linen service. Ideal for single busy professionals & couples.",
        card_two_image: "/assets/img/home/wing2.png",
        card_1: {
          card_one_title: "Laundry Bag",
          card_one_paragraph:
            "One bag = one price, fill it up and get it washed! Includes FREE next day delivery & all perks from Laundry Go. Ideal for couples & families. Plans start from £25/month",
          card_one_image: "/assets/img/home/wing1.png",
        },
        card_2: {
          card_two_title: "Ongoing discount on All Services",
          card_two_paragraph:
            "10% OFF all services (apart from laundry) for just £3.99/month. This includes Eco Dry Cleaning, shirt service & bed linen service. Ideal for single busy professionals & couples.",
          card_two_image: "/assets/img/home/wing2.png",
        },
      },
      section_8: {
        title: "What Our Client Say",
        cards: [
          {
            profile: "/assets/img/home/testimonialuser1.jpg",
            name: "Judy Wells",
            position: "Chairman and founder",
            message:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
            backgroundImage: "/assets/img/home/testimonialimg1.jpg",
          },
          {
            profile: "/assets/img/home/testimonialuser2.jpg",
            name: "Judy Wells two",
            position: "Chairman and founder",
            message:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
            backgroundImage: "/assets/img/home/testimonialimg2.jpg",
          },
          {
            profile: "/assets/img/home/testimonialuser3.jpg",
            name: "Judy Wells two",
            position: "Chairman and founder",
            message:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
            backgroundImage: "/assets/img/home/testimonialimg3.jpg",
          },
          {
            profile: "/assets/img/home/testimonialuser1.jpg",
            name: "Judy Wells",
            position: "Chairman and founder",
            message:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
            backgroundImage: "/assets/img/home/testimonialimg1.jpg",
          },
          {
            profile: "/assets/img/home/testimonialuser2.jpg",
            name: "Judy Wells two",
            position: "Chairman and founder",
            message:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
            backgroundImage: "/assets/img/home/testimonialimg2.jpg",
          },
          {
            profile: "/assets/img/home/testimonialuser3.jpg",
            name: "Judy Wells two",
            position: "Chairman and founder",
            message:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
            backgroundImage: "/assets/img/home/testimonialimg3.jpg",
          },
        ],
      },
      section_10: {
        title: "Latest News & Events",
        button: {
          text: "View More",
          bg_color: "#ffcb00",
          color: "ffffff",
          is_enable: true,
        },
      },
      section_7: {
        is_section_enable: true,
        title: "On Demand Laundry, Dry Cleaning and Ironing Service",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "/assets/img/laundry.png",
              card_title: "Laundry",
            },
            {
              _id: 2,
              icon: "/assets/img/alterations.png",
              card_title: "Alterations",
            },
            {
              _id: 3,
              icon: "/assets/img/dry cleaning.png",
              card_title: "Dry Cleaning",
            },
            {
              _id: 4,
              icon: "/assets/img/ironing.png",
              card_title: "Ironing",
            },
            {
              _id: 5,
              icon: "/assets/img/repairs.png",
              card_title: "Repairs",
            },
          ],
        },
      },
      section_9: {
        is_section_enable: true,
        title: "Frequently Asked Questions",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        paragraph:
          "online laundry & dry cleaning companies who simply just own the technology and farm the cleaning to other providers with little to no process system checks.",
        banner: [
          {
            banner: "/assets/img/faqimg.jpg",
          },
        ],
        card_heading: "CALL US FOR A FREE QUOTE ON:",
        card_number: "+(044) 071012345",
        card_buttontext: "Enquire Now",
        card_section: {
          collection: [
            {
              _id: 1,
              collection_title: "Do you have a re-cleaning Policy?",
              isEnabled: true,
              collection_paragraph:
                "Although we have quality control where we check each garment before we pack, if we are unable to remove stains we usually inform customers before. If something slips through and you are not completely satisfied with the quality of our dry cleaning, we will re-clean your item free of charge, as long as it’s within 24 hours.",
            },
            {
              _id: 2,
              collection_title: "Do you have policy grantees?",
              isEnabled: true,
              collection_paragraph: "Yes",
            },
          ],
        },
      },
      footer: {
        bg_color: "ffffff",
        section_heading_color: "ffffff",
        section_paragraph_color: "c2c2c2",
        mbl_number: "+442086388690",
        email_val: "sales@bestatlaundry.com",
        address_val: "81 Randall Drive, Hornchurch - RM126TA",
        footer_section: {
          social_media: {
            facebook: {
              is_enable: true,
              facebook_link: "facebook.com",
            },
            instagram: {
              is_enable: true,
              instagram_link: "instagram.com",
            },
            whatsapp: {
              is_enable: true,
              whatsapp_link: "whatsapp.com",
            },
            linkedin: {
              is_enable: true,
              linkedin_link: "linkedin.com",
            },
            youtube: {
              is_enable: true,
              youtube_link: "youtube.com",
            },
            twitter: {
              is_enable: true,
              twitter_link: "twitter.com",
            },
          },
        },
      },
    },
  },
  theme_2: {
    home: {
      sections: [
        {
          _id: 1,
          is_section_enable: true,
          icon: "/assets/section-two/section1.png",
        },
        {
          _id: 2,
          is_section_enable: true,
          icon: "/assets/section-two/section2.png",
        },
        {
          _id: 3,
          is_section_enable: true,
          icon: "/assets/section-two/section3.png",
        },
        {
          _id: 4,
          is_section_enable: true,
          icon: "/assets/section-two/section4.png",
        },
        {
          _id: 5,
          is_section_enable: true,
          icon: "/assets/section-two/section5.png",
        },
        {
          _id: 6,
          is_section_enable: true,
          icon: "/assets/section-two/section6.png",
        },
        {
          _id: 7,
          is_section_enable: true,
          icon: "/assets/section-two/section7.png",
        },
        {
          _id: 8,
          is_section_enable: true,
          icon: "/assets/section-two/section8.png",
        },
        {
          _id: 9,
          is_section_enable: true,
          icon: "/assets/section-two/section9.png",
        },
      ],
      header: {
        primary_color: "ff0059",
        secondary_color: "ffcb00",
        nav: {
          nav_bg_color: "ffffff",
          header_bg_color: "ffffff",
          menu_font_color: "2e3639",
          menu_font_color_active: "1b9db3",
          menu_font_color_hover: "f07f1b",
          icon_one_color: "f7e413",
          icon_two_color: "ff0051",
          icon_bg_color: "ffffff",
        },
        btn_group: {
          btn1: {
            text: "Continue to order",
            btn_bg_color: "ff0059",
            btn_color: "ffffff",
          },
          btn2: {
            btn2_text: "Order Now",
            btn2_bg_color: "ffcb00",
            btn2_color: "2e3639",
          },
        },
      },
      section_1: {
        title_1: "Solution for your",
        title_2: "Laundry & Dry Cleaning Service",
        title_3: "Highest quality and lowest price guaranteed.",
        btntext: "Book Now",
        btnbg_color: "ffcb00",
        btncolor: "2e3639",
        btnplaceholder: "Enter Postcode",
        card_section: [
          "/assets/img/theme_2/banner-slider-01.jpg",
          "/assets/img/theme_2/banner-slider-02.jpg",
          "/assets/img/theme_2/banner-slider-03.jpg",
          "/assets/img/theme_2/banner-slider-04.jpg",
          "/assets/img/theme_2/banner-slider-05.jpg",
        ],
      },
      section_2: {
        is_section_enable: true,
        banner: "/assets/img/trustimg2.png",
        sub_heading_top: "Our Introduction",
        title: "Welcome",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "191919",
        mainparagraph:
          "There are many variations of passag of lorem ipsum available but the majority have suffered alteration in some form by injected humour randomised words which don't look even slightly believable.There are many variations of passag of lorem ipsum available but the majority have suffered alteration in some form by injected humour randomised words which don't look even slightly believable.",
        card_section_one: [
          {
            _id: 1,
            text: "Dry Cleaning",
            count: "12K",
          },
          {
            _id: 2,
            text: "Satisfied Clients",
            count: "20K",
          },
          {
            _id: 3,
            text: "Happy Customers",
            count: "8K",
          },
        ],
        card_section_title: "Top rated laundry",
        rating: "5",
        card_sub_text: "(30k Reviews)",
        card_section_two: [
          {
            _id: 1,
            card_icon: "/assets/icons/priorityicon1_2.svg",
            card_sub_heading_top: "Claim Support",
            card_title: "24/7 Supports",
            card_paragraph:
              "We love to help you to get your clothes fresh and clean so we are here for you 24/7 for any question, concern or suggestion.",
          },
          {
            _id: 2,
            card_icon: "/assets/icons/priorityicon1_2.svg",
            card_sub_heading_top: "100% Reliable",
            card_title: "Offers & cares",
            card_paragraph:
              "Every item sent to dry cleaning or Laundromat, hands of experts who take care of your garments in detailed way.",
          },
          {
            _id: 3,
            card_icon: "/assets/icons/priorityicon1_2.svg",
            card_sub_heading_top: "Consultation",
            card_title: "Expert teams",
            card_paragraph:
              "With our subscription, you can set up your services and never worry about laundry or for dry cleaning again.",
          },
        ],
      },
      section_3: {
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "191919",
        cards: [
          {
            bg_img: "/assets/img/home/wing1.png",
            card_title: "Any Special Cleaning Instructions for us?",
            card_paragraph:
              "Please Handle carefully, Plink sweater has a delicate embroidery and needs additional care.",
            services: [
              { id: "1", list: "Laundry" },
              { id: "2", list: "Dry Cleaning" },
              { id: "3", list: "Ironing" },
            ],
            card_main_title: "We pick up your valuable Clothes",
            card_main_paragraph:
              "Our delivery services work no matter where you are. Do you need your clothes dropped off at your place of work? We can do that for you. We’ll drop it off at your house, apartment, or even at your hotel.",
            card_options: [
              { id: "1", list: "100% Customer Satisfaction" },
              { id: "2", list: "Affordable Prices" },
              { id: "3", list: "Free Collection & Delivery" },
              { id: "4", list: "Best Quality" },
            ],
          },
          {
            bg_img: "/assets/img/home/wing2.png",
            card_title: "Order Scheduled",
            card_paragraph:
              "Download our app or visit our website to start your laundry order.",
            services: [
              { id: "1", list: "Pay Online in Seconds" },
              { id: "2", list: "Eco-Friendly" },
              { id: "3", list: "Save Time & Money" },
            ],
            card_main_title: "Pack up your valuable Clothes",
            card_main_paragraph:
              "Pack the item in a disposable bag, use one bag per service, our driver will transfer them to a reusable laundry heap bag that you can save for your next order, pack one bag per service, no need to count or weight the items, efficient water use",
            card_options: [
              { id: "1", list: "100% Customer Satisfaction" },
              { id: "2", list: "Affordable Prices" },
              { id: "3", list: "Free Collection & Delivery" },
              { id: "4", list: "Best Quality" },
            ],
          },
          {
            bg_img: "/assets/img/home/wing3.png",
            card_title: "Order Scheduled",
            card_paragraph:
              "Download our app or visit our website to start your laundry order.",
            services: [
              { id: "1", list: "Competitive Price" },
              { id: "2", list: "5 Star Rated" },
            ],
            card_main_title: "Wait for driver to pick up Clothes",
            card_main_paragraph:
              "Get notified when your driver is nearby. They will pick up your bag and take it to a local cleaning facility. Regular order updates, live driver tracking, zero-emission delivery vehicles, trusted local cleaners, and convenient laundry solutions those help save the environment.",
            card_options: [
              { id: "1", list: "100% Customer Satisfaction" },
              { id: "2", list: "Affordable Prices" },
              { id: "3", list: "Free Collection & Delivery" },
              { id: "4", list: "Best Quality" },
            ],
          },
          {
            bg_img: "/assets/img/home/wing4.png",
            card_title: "Order Picked",
            card_paragraph:
              "Download our app or visit our website to start your laundry order.",
            services: [
              { id: "1", list: "24h turnaround time" },
              { id: "2", list: "Easy to reschedule" },
            ],
            card_main_title: "We take care of your Clothes",
            card_main_paragraph:
              "Items will be meticulously cleaned by a local partner facility. Our driver will bring them whenever you want. You are in complete control of your deliveries and can reschedule at any time if you are not home.24 hour processing time, real-time order status and easy rescheduling",
            card_options: [
              { id: "1", list: "100% Customer Satisfaction" },
              { id: "2", list: "Affordable Prices" },
              { id: "3", list: "Free Collection & Delivery" },
              { id: "4", list: "Best Quality" },
            ],
          },
        ],
      },
      section_4: {},
      section_5: {
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "191919",
        title: "Compare our Services",
        cards: [
          {
            card_title: "",
            icon: "/assets/img/icons/serviceicon2.svg",
            card_options: [
              { id: "1", list: "What is included" },
              { id: "2", list: "Typically included items" },
              { id: "3", list: "Service time" },
              { id: "4", list: "Delivery" },
              { id: "5", list: "Items returned" },
              { id: "6", list: "Eco friendly" },
            ],
          },
          {
            card_title: "Laundry Services",
            icon: "/assets/img/icons/serviceicon2.svg",
            card_options: [
              { id: "1", list: "Wash + Tumble-Dry" },
              { id: "2", list: "T-shirts, trousers, bedsheets." },
              { id: "3", list: "Service time 24h*" },
              { id: "4", list: "Delivery FREE" },
              { id: "5", list: "Items returned in a bag" },
              { id: "6", list: "Eco friendly" },
            ],
          },
          {
            card_title: "Dry Cleaning Services",
            icon: "/assets/img/icons/serviceicon3.svg",
            card_options: [
              { id: "1", list: "Dry Cleaning + Ironing" },
              { id: "2", list: "Suits, shirts, dresses and coats." },
              { id: "3", list: "Service time 24h*" },
              { id: "4", list: "Delivery FREE" },
              { id: "5", list: "Items returned in a bag" },
              { id: "6", list: "Eco friendly" },
            ],
          },
          {
            card_title: "Ironing Services",
            icon: "/assets/img/icons/serviceicon4.svg",
            card_options: [
              { id: "1", list: "Ironing" },
              { id: "2", list: "Shirts, t-shirts and bedsheets." },
              { id: "3", list: "Service time 24h*" },
              { id: "4", list: "Delivery FREE" },
              { id: "5", list: "Items returned in a bag" },
              { id: "6", list: "Eco friendly" },
            ],
          },
        ],
      },
      section_6: {
        collection: [
          {
            collection_title: "Do you have a re-cleaning Policy?",
            collection_paragraph:
              "Although we have quality control where we check each garment before we pack, if we are unable to remove stains we usually inform customers before. If something slips through and you are not completely satisfied with the quality of our dry cleaning, we will re-clean your item free of charge, as long as it’s within 24 hours.",
          },
          {
            collection_title: "Do you have a loss policy?",
            collection_paragraph:
              "We take full responsibility for the clothes from the moment we issue a ticket or pick up from you. Even though we exercise the utmost care, there will be instances where items may get misplaced or lost. Should you have reason to believe that we have lost or misplaced your item. Missing items must be reported to us within 24 hours with descriptions so that we can trace your garment. In the unlikely event of losing any of your items, bestatlaundry liability with respect to any lost item shall not exceed ten (10) times our charge for cleaning that garment regardless of brand or condition.",
          },
          {
            collection_title: "Do you have a safe keeping policy?",
            collection_paragraph:
              "We take responsibility to keep your clothes safe for a maximum of 60 days. Should you be unable to pick your clothes within 60 days, due to holiday, illness, etc. please let us know ASAP and we shall arrange to keep your garments safely for an agreed time period. Otherwise, due to storage, we will have to give your clothes to charity.",
          },
          {
            collection_title: "Do you have a privacy statement?",
            collection_paragraph:
              "We respect our customer’s privacy and do not sell any identifiable information regarding our customers to any third party. Any information you give us is held with the utmost care and security, and will not be used in ways to which you have not consented.",
          },
          {
            collection_title: "Do you have a garment damage policy?",
            collection_paragraph:
              "Whilst every care is taken handling your clothes, if you believe that we have damaged your garments in any way please contact as within 24 hours. We will do our best to resolve the situation. We will investigate thoroughly and if we feel that we were negligent we shell pay fair compensation based upon the current value of the garment. This is usually around 6-10 times the cost of the dry cleaning. Our damage policy is in line with the Office of Fair Trades recommendations.",
          },
          {
            collection_title: "How should my garments be cleaned?",
            collection_paragraph:
              "As we are experts at dealing with all garments that come our way. When they arrive at our premises, your garments are examined carefully and then cleaned under the manufacturer’s instructions. Our cleaning is as gentle and delivers better results than traditional dry cleaning. If there’s any doubt or we can’t find a care label, we will clean at what we call “owner’s risk” (as we can sadly not accept any liability for garments where there are no instructions). If we feel there is really too much of a risk to your garment and we cannot get in touch with you, we will return the item to you uncleaned.",
          },
          {
            collection_title: "How long does it take to clean my items?",
            collection_paragraph:
              "We aim to collect your clothes, give them our expert care and attention and deliver them back to you within working 48 hours. There might be some exceptions: In some instances, your preferred delivery slot may not be available. This is mainly because we have already reached full capacity for that time slot, or because we do not visit your area as often as we would like at this moment. We apologise for any inconvenience caused and assure you that we are working very hard to increase our time slot capacity. Some items such as bed linen, curtains, leather, or tailoring may take longer to process as they will be entrusted to various experts. The delivery timing will be provided to you as soon as the respective items have been inspected at our premises. On inspection, we might consider that it will take longer to remove particularly difficult stains or other issues with fabrics. We offer an express service with same-day turnaround* in all our stores however due to logistical constraints thi",
          },
          {
            collection_title:
              "Why can I not select my preferred delivery slot?",
            collection_paragraph:
              "In some instances, your preferred delivery slot may not be available. This could be because we have already reached full capacity for that time slot. We apologize for any inconvenience caused and assure you that we are working very hard to increase our time slot capacity. Should you wish to drop us a line and check to see if we accommodate your chosen slot or to see if there is any cancellation please email info@bestatlaundry.uk",
          },
          {
            collection_title: "How do I order online?",
            collection_paragraph:
              "Simply click Book Now in the top right-hand corner. On the next screen, you will be able to choose a pickup time that we will collect the clothing items from your home/concierge and a dropoff time where we will drop the dry cleaned clothes back to your home/concierge. The next screen is where you can choose your items either select the items directly or choose a category and the system will refine the items to help you choose. Simply choose the quantity and select add to put the item in your basket. When ready click with view basket or the basket in the top right-hand corner of the page you can then check out adding your address and any special requirements. Lastly, you can pay using any credit or debit card using our encrypted service with stripe. We will then process your order and arrive at your requested time slot ready to pick up your items.",
          },
          {
            collection_title: "can I book a regular pickup & delivery?",
            collection_paragraph:
              "Yes! If you want to book a regular pickup and delivery slot each week, just email us to info@bestatlaundry.uk This saves having to deal with laundry and to re-book on a regular basis, and you can cancel at any time if you don’t need a delivery that week. Although it is currently not possible to book a recurring time slot online, you can call our customer care team and we will gladly set this up.",
          },
          {
            collection_title: "How do I know when my driver will arrive?",
            collection_paragraph:
              "We currently offer 1-hour time slots, which allows for traffic and our logistical requirements, if our driver is later than the chosen time slot we will contact you.",
          },
          {
            collection_title: "Why do you not cover my area?",
            collection_paragraph:
              "We are continually growing and expanding and while we might not currently cover your area. Send a message with your details to info@bestatlaundry.uk and as soon as we start to serve your area, we will contact you. You can also mail us to info@bestatlaundry.uk as they will often be able to arrange a special courier or Uber service for you (delivery fees will apply).",
          },
          {
            collection_title: "How will I be charged for the order",
            collection_paragraph:
              "We use a highly secure platform to register your credit or debit card and collect payment. After picking up your clothes, our experts will examine them and determine the total amount of your invoice based on the extent of the work that needs to be carried out on each item (much as a till assistant would do in-store). Until then, you can get an estimate of your order according to our price list here. We are unable to be more exact at this stage because some items require more time and specific treatment, and we can’t know the detail of this before we examine your garments. Once this is done, we will send you an email detailing your invoice, item by item, and charge your card on that basis. If you disagree with anything that we have detailed on your invoice, please feel free email us to info@bestatlaundry.uk and we will be happy to look into this for you. Kindly note that we cannot accept cash payment for deliveries.",
          },
          {
            collection_title: "What does owner's risk mean?",
            collection_paragraph:
              "Some fragile or highly sensitive garments inherently have a risk in cleaning, this could be due to fabric, age, colour, pre-existing damage etc. thus meaning there is a risk that they could be damaged in the cleaning process, in this instance we will refrain from cleaning the garment in question. We will make an attempt to contact you and advise you of the potential risks associated with proceeding with the treatment. Note that if you authorise us to proceed, it will imply that you assume full responsibility for any damage to the garments. In certain circumstances, we may still return the garment and advise not to clean it as damage is inevitable.",
          },
          {
            collection_title:
              "can we dry clean wedding dresses and other bespoke items?",
            collection_paragraph:
              "We are the experts at cleaning these pieces. Please note that the sooner you bring your dress in after your wedding, the better the results we can achieve, as leaving little time for stains to set helps us to get that better finish. We can also clean other bespoke items – just ask one of your store assistants for a quote, email us info@bestatlaundry.uk if you would like more information or to ask for a quote. Kindly note that we assess all those very specific items before cleaning to ensure that we have spotted and highlighted all the potential risks to you before proceeding with the clean.",
          },
        ],
      },
      section_7: {
        title_1: "Latest Testimonial",
        title_2: "What Our Client Say",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "191919",
        cards: [
          {
            profile: "/assets/home/testimonialuser1.jpg",
            name: "Judy Wells",
            designation: "Chairman and founder",
            message:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
          {
            profile: "/assets/home/testimonialuser2.jpg",
            name: "Judy Wells",
            designation: "Chairman and founder",
            message:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
          {
            profile: "/assets/home/testimonialuser3.jpg",
            name: "Judy Wells",
            designation: "Chairman and founder",
            message:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
          {
            profile: "/assets/home/testimonialuser1.jpg",
            name: "Judy Wells",
            designation: "Chairman and founder",
            message:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
          {
            profile: "/assets/home/testimonialuser2.jpg",
            name: "Judy Wells",
            designation: "Chairman and founder",
            message:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
          {
            profile: "/assets/home/testimonialuser3.jpg",
            name: "Judy Wells",
            designation: "Chairman and founder",
            message:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
        ],
      },
      section_8: {
        title_1: "ARTICLES",
        title_2: "Latest News",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "191919",
      },
      section_9: {
        title: "We're available on mobile Just download it!",
        paragraph:
          "Download the our app and request our laundry service. Your clothes washed, folded and delivered to your doorstep. So go ahead and say yes to more time with the family, more happy hours, and more slapping the snooze button every morning — we've got laundry day covered.",
        android_link:
          "https://play.google.com/store/apps/details?id=co.in.dreamguys.bestatlaundry",
        ios_link:
          "https://itunes.apple.com/us/app/best-laundry/id1434880614?ls=1&mt=8",
        banner: "/assets/img/iPhone13.png",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "191919",
      },
      footer: {
        custome_banner_design: {
          is_enable: true,
        },
        bg_color: "151e2e",
        section_heading_color: "ffffff",
        section_paragraph_color: "c2c2c2",
        mbl_number: "+442086388690",
        email_val: "sales@bestatlaundry.com",
        address_val: "81 Randall Drive, Hornchurch - RM126TA",
        footer_section: {
          about_section: {
            is_enable: true,
            text: "Ready to take laundry off your to-do list? Bestatlaundry services is a local laundry pickup and delivery service that you can order directly from your smart phone.",
          },
          service_section: {
            is_enable: true,
          },
          quicklink_section: {
            is_enable: true,
          },
          callnow_for_Services_section: {
            is_enable: true,
            mbl_no: {
              label: "+442086388690",
              value: "tel:+442086388690",
            },
            email: {
              label: "Email Us",
              value: "sales@bestatlaundry.com",
            },
            address: {
              text: "81 Randall Drive, Hornchurch - RM126TA",
            },
          },
          social_media: {
            facebook: {
              is_enable: true,
              facebook_link: "facebook.com",
            },
            instagram: {
              is_enable: true,
              instagram_link: "instagram.com",
            },
            whatsapp: {
              is_enable: true,
              whatsapp_link: "whatsapp.com",
            },
            linkedin: {
              is_enable: true,
              linkedin_link: "linkedin.com",
            },
            youtube: {
              is_enable: true,
              youtube_link: "youtube.com",
            },
            twitter: {
              is_enable: true,
              twitter_link: "twitter.com",
            },
          },
        },
      },
    },
  },
  theme_3: {
    home: {
      sections: [
        {
          _id: 1,
          is_section_enable: true,
          icon: "/assets/section/section1.jpg",
        },
        {
          _id: 3,
          is_section_enable: true,
          icon: "/assets/section/section3.jpg",
        },
        {
          _id: 4,
          is_section_enable: true,
          icon: "/assets/section/section4.jpg",
        },
        {
          _id: 5,
          is_section_enable: true,
          icon: "/assets/section/section5.jpg",
        },
        {
          _id: 6,
          is_section_enable: true,
          icon: "/assets/section/section6.jpg",
        },
        {
          _id: 7,
          is_section_enable: true,
          icon: "/assets/section/section7.jpg",
        },
        {
          _id: 8,
          is_section_enable: true,
          icon: "/assets/section/section8.jpg",
        },
        {
          _id: 9,
          is_section_enable: true,
          icon: "/assets/section/section9.jpg",
        },
        {
          _id: 10,
          is_section_enable: true,
          icon: "/assets/section/section10.jpg",
        },
        {
          _id: 11,
          is_section_enable: true,
          icon: "/assets/section/section11.jpg",
        },
        {
          _id: 12,
          is_section_enable: true,
          icon: "/assets/section/section12.jpg",
        },
        {
          _id: 13,
          is_section_enable: true,
          icon: "/assets/section/section13.jpg",
        },
        {
          _id: 15,
          is_section_enable: true,
          icon: "/assets/section/section15.jpg",
        },
      ],
      header: {
        is_section_enable: true,
        primary_color: window.location.href.includes("sheercare")
          ? "8FA282"
          : "1B9DB3",
        secondary_color: window.location.href.includes("sheercare")
          ? "474747"
          : "F07F1B",
        nav: {
          bg_color: window.location.href.includes("sheercare")
            ? "8FA282"
            : "ffffff",
          menu_font_color: window.location.href.includes("sheercare")
            ? "ffffff"
            : "2e3639",
          menu_font_color_active: window.location.href.includes("sheercare")
            ? "ffffff"
            : "1b9db3",
          menu_font_color_hover: "f07f1b",
          cart_section: {
            is_enable: true,
            bg_color: "ffffff",
            cart_icon_color: "ffffff",
            cart_icon_bg_color: "#f07f1b",
            cart_label_section: {
              label: "items : ",
              color: "#6b7385",
            },
            cart_value_color: "000000",
          },
        },
        btn_group: {
          btn1: {
            text: "Login / Register",
            bg_color: "ffffff",
            color: "1b9db3",
            border_color: "1b9db3",
            btn1_is_enable: true,
          },
          btn2: {
            text: "Quick Order",
            color: "ffffff",
            bg_color: "000",
            border_color: "192335",
            btn2_is_enable: true,
          },
        },
      },
      section_1: {
        is_section_enable: true,
        banner_type: "image",
        banner: window.location.href.includes("sheercare")
          ? "https://api.sheercare.uk/storage/compress_images/655759aec0b70.jpeg"
          : "/assets/home_page_single_search.jpg",
        banner_two: window.location.href.includes("sheercare")
          ? ""
          : "/assets/home/heroimg.png",
        sub_heading_top: "24/7 Dry Cleaning & Laundry Service",
        title: "One Solution for all your Washing Needs",
        paragraph:
          "Bestatlaundry is synonymous with quality, reliability, and trust. We provide fast dry cleaning and laundry services in and around London. Advance online technology and modern process and equipment utilization means affordable cost to all our customers.",
        btn_group: {
          btn1: {
            text: "Book now",
            bg_color: "#1b9db3",
            color: "ffffff",
            placeholder: "Enter Postalcode",
          },
        },
        mobile_link_section: {
          is_enable: true,
          mob_title: "Just A Click Away",
          android_link: "#",
          ios_link: "#",
        },
      },
      section_2: {
        is_section_enable: true,
        sub_heading_top: "Book A Service",
        title: "Select Your Time & Location For The Service",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        btn_group: {
          btn1: {
            text: "order now",
            bg_color: "#1b9db3",
            color: "ffffff",
          },
        },
      },
      section_3: {
        is_section_enable: true,
        sub_heading_top: "Dry Cleaning & Laundry",
        title: "Trust The Expert On Laundry Services",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        paragraph:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "/assets/icons/priorityicon1.png",
              collection_title: "Top Quality",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 2,
              icon: "/assets/icons/priorityicon2.png",
              collection_title: "Best Service",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 3,
              icon: "/assets/icons/priorityicon3.png",
              collection_title: "Value",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 4,
              icon: "/assets/icons/priorityicon4.png",
              collection_title: "Professionalism",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 5,
              icon: "/assets/icons/priorityicon5.png",
              collection_title: "Convenience",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 6,
              icon: "/assets/icons/priorityicon6.png",
              collection_title: "Cleanliness",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
          ],
          btn_group: {
            btn1: {
              text: "More About Us",
              bg_color: "192335",
              color: "ffffff",
            },
          },
        },
      },
      section_4: {
        is_section_enable: true,
        title:
          "Bestatlaundry is Ranked #1 by customers in the UK in categories of dry cleaning",
        h2color: "ffffff",
      },
      section_5: {
        is_section_enable: true,
        banner: [
          {
            banner: "/assets/home/howwe1.jpg",
          },
        ],
        title: "We collect, clean, & deliver your laundry & dry cleaning.",
        paragraph:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
        h2color: "2e3639",
        paracolor: "6d7a80",
        check_list: [
          {
            _id: 1,
            list: "Free same day collection",
          },
          {
            _id: 2,
            list: "24h turnaround time",
          },
          {
            _id: 3,
            list: "Dedicated 24/7 support",
          },
          {
            _id: 4,
            list: "Standard wash for just £14",
          },
          {
            _id: 5,
            list: "Wash & Fold for items that don't need pressing",
          },
          {
            _id: 6,
            list: "Free collection and delivery",
          },
        ],
        btn_group: {
          btn1: {
            text: "Schedule a Collection Now",
            bg_color: "#192335",
            color: "ffffff",
            is_enable: true,
          },
          btn2: {
            text: "Request a Pickup",
            bg_color: "#1b9db3",
            color: "ffffff",
            is_enable: true,
          },
        },
      },
      section_6: {
        is_section_enable: true,
        sub_heading_top: "Know More On",
        title: "How We Works",
        paragraph:
          "We collect, clean and deliver your clothes within 24-48 hrs.",
        h2color: "ffffff",
        h2subcolor: "ffffff",
        h3color: "2e3639",
        paracolor: "6d7a80",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "/assets/home/howwe1.jpg",
              card_title: "Online Order",
              card_paragraph:
                "Use our friendly and easy access website or app to place your laundry order. choose a suitable pickup location and time.",
            },
            {
              _id: 2,
              icon: "/assets/home/howwe2.jpg",
              card_title: "Transport",
              card_paragraph:
                "Our registered driver will pick up your laundry at your doorstep and transport the laundry safely to one of our many trusted dry cleaning facilities.",
            },
            {
              _id: 3,
              icon: "/assets/home/howwe3.jpg",
              card_title: "Dry Cleaning",
              card_paragraph:
                "Our registered driver will pick up your laundry at your doorstep and transport the laundry safely to one of our many trusted dry cleaning facilities.",
            },
            {
              _id: 4,
              icon: "/assets/home/howwe4.jpg",
              card_title: "Door Delivery",
              card_paragraph:
                "Dry and clean clothes were carefully bagged and delivered to your doorstep.",
            },
          ],
          btn_group: {
            paragraph: "Lorem Ipsum is simply dummy text of the",
            btn1: {
              text: "Book Online Now",
              bg_color: "#192335",
              color: "#ffffff",
            },
          },
        },
      },
      section_7: {
        is_section_enable: true,
        title: "On Demand Laundry, Dry Cleaning And Ironing Categories",
        paragraph:
          "We provide commercial laundry, shoe repair, clothing alteration, tailoring and wedding dress fitting services in London, Essex, Kent, Westminster, Chelsea, Dartford, Croydon, Enfield, Basildon, South On Sea, Bromley, Mayfair, Romford and other areas in London.",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "/assets/img/laundry.png",
              card_title: "Laundry",
            },
            {
              _id: 2,
              icon: "/assets/img/alterations.png",
              card_title: "Alterations",
            },
            {
              _id: 3,
              icon: "/assets/img/dry cleaning.png",
              card_title: "Dry Cleaning",
            },
            {
              _id: 4,
              icon: "/assets/img/ironing.png",
              card_title: "Ironing",
            },
            {
              _id: 5,
              icon: "/assets/img/repairs.png",
              card_title: "Repairs",
            },
          ],
        },
        btn_group: {
          btn_paragraph: "Lorem Ipsum is simply dummy text of the",
          btn1: {
            text: " Request a Pickup",
            bg_color: "192335",
            color: "fff",
          },
        },
      },
      section_8: {
        is_section_enable: true,
        banner: "howwe1",
        title: "About Us",
        section_image: "/assets/home/trustimg2.jpg",
        paragraph:
          "Bestatlaundry is synonymous with quality, reliability, and trust. We provide fast dry cleaning and laundry services in and around London. Advance online technology and modern process and equipment utilization means affordable cost to all our customers.",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "James please use React import aliase",
              collection_title: "Free Pick up and Delivery",
              collection_image: "/assets/icons/priorityicon7.png",
              isEnabled: true,
              collection_paragraph:
                "We offer a convenient way to have laundry picked up and delivered for free.",
            },
            {
              _id: 2,
              icon: "James please use React import aliase",
              collection_title: "High Quality of Services",
              collection_image: "/assets/icons/priorityicon8.png",
              isEnabled: true,
              collection_paragraph:
                "Our laundry team perfectly cleans, iron, fold, pack, and deliver to you on time.",
            },
            {
              _id: 3,
              icon: "James please use React import aliase",
              collection_title: "Affordable Cost",
              collection_image: "/assets/icons/priorityicon9.png",
              isEnabled: true,
              collection_paragraph:
                "We offer affordable prices when compared to the current market.",
            },
          ],
        },
        btn_group: {
          btn1_text: "Schedule a Collection Now",
          btn1_bg_color: "192335",
          btn1_color: "ffffff",
          btn2_text: "Request a Pickup",
          btn2_bg_color: "1b9db3",
          btn2_color: "ffffff",
        },
      },
      section_9: {
        is_section_enable: true,
        section_bg_color: "#1b9db3",
        sub_heading_top: "Our Promising Services",
        title: "On Demand Laundry, Dry Cleaning And Ironing Service",
        paragraph:
          "We collect, clean and deliver your clothes within 24-48 hrs.",
        h2color: "ffffff",
        h3color: "2e3639",
        paracolor: "6d7a80",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "/assets/home/priorityimg1.jpg",
              collection_title: "Laundry",
              collection_paragraph:
                "A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.",
            },
            {
              _id: 2,
              icon: "/assets/home/priorityimg2.jpg",
              collection_title: "Dry Cleaning",
              collection_paragraph:
                "A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.",
            },
            {
              _id: 3,
              icon: "/assets/home/priorityimg3.jpg",
              collection_title: "Alteration & Repair",
              collection_paragraph:
                "A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.",
            },
            {
              _id: 14,
              icon: "/assets/home/priorityimg1.jpg",
              collection_title: "Laundry",
              collection_paragraph:
                "A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.",
            },
          ],
          count_section: [
            {
              _id: 1,
              icon: "/assets/icons/priorityicon1.png",
              text: "Laundry Clothes",
              count: "1639+",
            },
            {
              _id: 2,
              icon: "/assets/icons/priorityicon2.png",
              text: "Steam Ironing",
              count: "24359+",
            },
            {
              _id: 3,
              icon: "/assets/icons/priorityicon3.png",
              text: "Dry Cleaning",
              count: "4793+",
            },
            {
              _id: 4,
              icon: "/assets/icons/priorityicon4.png",
              text: "Cleaning programs",
              count: "25+",
            },
          ],
        },
      },
      section_10: {
        is_section_enable: true,
        banner: "/assets/home/trustimg3.png",
        sub_heading_top: "Your Health & Safety Is Our Priority",
        title: "Our Values",
        mainparagraph:
          "online laundry & dry cleaning companies who simply just own the technology and farm the cleaning to other providers with little to no process system checks.",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        cardcolor: "ffffff",
        list_Section: [
          {
            _id: 1,
            text: "Contactless deliveries",
            paragraph:
              "For our customers safety, we enabled the feature to allow customers to conduct contactless pick up & deliveries.",
          },
          {
            _id: 2,
            text: "Instant updates",
            paragraph:
              "We’ll keep you posted throughout the process with texts/emails when driver is on their way and order has been cleaned.",
          },
          {
            _id: 3,
            text: "Monitoring the situation",
            paragraph:
              "We’re keeping up to date with all developments from government to ensure the safety of our customers and staff.",
          },
        ],
        card_section_title: "We use Eco-friendly Laundry Detergent Sheets.",
        card_section: [
          {
            _id: 1,
            card_bg_color: "192335",
            card_text: "Vegan",
            card_paragraph:
              "Our vegan-friendly laundry detergent is free from any animal product.",
          },
          {
            _id: 2,
            card_bg_color: "f07f1b",
            card_text: "Cruelty Free",
            card_paragraph:
              "We never test on animals – so our Laundry Leaves will always be cruelty-free.",
          },
          {
            _id: 3,
            card_bg_color: "1bb333",
            card_text: "Eco-Friendly",
            card_paragraph:
              "Free from any harmful chemicals or pollutants and are devoid of harmful toxins.",
          },
        ],
      },
      section_11: {
        is_section_enable: true,
        banner: [
          {
            banner: "/assets/home/howwe1.jpg",
          },
        ],
        card_section: {
          collection: [
            {
              _id: 1,
              collection_title: "Free Pick up and Delivery",
              isEnabled: true,
              collection_paragraph:
                "We offer a convenient way to have laundry picked up and delivered for free.",
            },
            {
              _id: 2,
              collection_title: "High Quality of Services",
              isEnabled: true,
              collection_paragraph:
                "Our laundry team perfectly cleans, iron, fold, pack, and deliver to you on time.",
            },
            {
              _id: 3,
              collection_title: "Affordable Cost",
              isEnabled: true,
              collection_paragraph:
                "We offer affordable prices when compared to the current market.",
            },
          ],
        },
        sub_heading_top: "Ask Your Question",
        title: "Frequently Asked Questions",
        paragraph:
          "online laundry & dry cleaning companies who simply just own the technology and farm the cleaning to other providers with little to no process system checks.",
        h2color: "2e3639",
        paracolor: "6d7a80",
      },
      section_12: {
        is_section_enable: true,
        banner: "howwe1",
        sub_heading_top: "What Our Client Says",
        title: "A Trusted Laundry And Dry Cleaning Company",
        paragraph: "Read what our customers say about us",
        review_bottom_paragraph:
          "More than 5,000+ reviews s on TrustPilot, Google, Google Play & App Store",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        review_card: [
          {
            _id: 1,
            reviewer_pic: "/assets/home/testimonialuser1.jpg",
            reviewer_name: "Ariyan Rusov",
            rating: "5",
            review_highlight: "Finibus mauris. Aliquam consectetur",
            review:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
          {
            _id: 2,
            reviewer_pic: "/assets/home/testimonialuser2.jpg",
            reviewer_name: "Darren Valdez",
            rating: "4",
            review_highlight: "Finibus mauris. Aliquam consectetur",
            review:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
          {
            _id: 3,
            reviewer_pic: "/assets/home/testimonialuser3.jpg",
            reviewer_name: "Elinor Dunn",
            rating: "5",
            review_highlight: "Finibus mauris. Aliquam consectetur",
            review:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
        ],
        btn_group: {
          btn1: {
            text: "Book Online Now",
            bg_color: "#192335",
            color: "#ffffff",
            is_enable: true,
          },
        },
      },
      section_13: {
        is_section_enable: true,
        banner: "/assets/home/iPhone11.png",
        title: "Just A Click Away",
        paragraph: "Download Our Best Active Mobile App",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        check_list: [
          {
            _id: 1,
            icons: "/assets/icons/priorityicon14.png",
            title: "Cashless payments",
          },
          {
            _id: 2,
            icons: "/assets/icons/priorityicon15.png",
            title: "Delivery in less then 24 hours",
          },
          {
            _id: 3,
            icons: "/assets/icons/priorityicon16.png",
            title: "Standard wash for just £14",
          },
          {
            _id: 4,
            icons: "/assets/icons/priorityicon17.png",
            title: "In-app live chat support",
          },
        ],
        mobile_link_section: {
          is_enable: true,
          android_link:
            "https://play.google.com/store/apps/details?id=co.in.dreamguys.bestatlaundry",
          ios_link:
            "https://itunes.apple.com/us/app/best-laundry/id1434880614?ls=1&mt=8",
        },
      },
      section_14: {
        is_section_enable: true,
        section_bg_color: "#1b9db3",
        title:
          "Subscribe to our newsletter for updates, exclusive promotions and our latest content!",
        btn_group: {
          btn1: {
            text: "Subscribe",
            bg_color: "#192335",
            color: "ffffff",
          },
        },
      },
      section_15: {
        is_section_enable: true,
        sub_heading_top: "Our Latest",
        title: "News & Events",
        paragraph:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
        h2color: "2e3639",
        h3color: "ffffff",
        paracolor: "6d7a80",
        btn_group: {
          btn1: {
            text: "More News & Events",
            bg_color: "#192335",
            color: "ffffff",
          },
        },
      },
      footer: {
        custome_banner_design: {
          is_enable: true,
        },
        bg_color: "151e2e",
        section_heading_color: "ffffff",
        section_paragraph_color: "c2c2c2",
        footer_section: {
          about_section: {
            is_enable: true,
            text: "Ready to take laundry off your to-do list? Bestatlaundry services is a local laundry pickup and delivery service that you can order directly from your smart phone.",
          },
          service_section: {
            is_enable: true,
          },
          quicklink_section: {
            is_enable: true,
          },
          callnow_for_Services_section: {
            is_enable: true,
            mbl_no: {
              is_enable: true,
              label: "+442086388690",
              value: "tel:+442086388690",
            },
            email: {
              label: "Email Us",
              value: "sales@bestatlaundry.com",
            },
            mbl_no_two: {
              is_enable: true,
              label: "+442086388690",
              value: "tel:+442086388690",
            },
            email_two: {
              label: "Email Us",
              value: "sales@bestatlaundry.com",
            },
            address: {
              text: "81 Randall Drive, Hornchurch - RM126TA",
            },
          },
          social_media: {
            facebook: {
              is_enable: true,
              facebook_link: "facebook.com",
            },
            instagram: {
              is_enable: true,
              instagram_link: "instagram.com",
            },
            whatsapp: {
              is_enable: true,
              whatsapp_link: "whatsapp.com",
            },
            linkedin: {
              is_enable: true,
              linkedin_link: "linkedin.com",
            },
            youtube: {
              is_enable: true,
              youtube_link: "youtube.com",
            },
            twitter: {
              is_enable: true,
              twitter_link: "twitter.com",
            },
          },
        },
      },
    },
  },
  theme_4: {
    home: {
      sections: [
        {
          _id: 1,
          is_section_enable: true,
          icon: "/assets/sections-four/Section_1.png",
        },
        {
          _id: 2,
          is_section_enable: true,
          icon: "/assets/sections-four/Section_2.png",
        },
        {
          _id: 3,
          is_section_enable: true,
          icon: "/assets/sections-four/Section_3.png",
        },
        {
          _id: 4,
          is_section_enable: true,
          icon: "/assets/sections-four/Section_4.png",
        },
        {
          _id: 5,
          is_section_enable: true,
          icon: "/assets/sections-four/Section_5.png",
        },
        {
          _id: 6,
          is_section_enable: true,
          icon: "/assets/sections-four/Section_6.png",
        },
        {
          _id: 7,
          is_section_enable: true,
          icon: "/assets/sections-four/Section_7.png",
        },
        {
          _id: 8,
          is_section_enable: true,
          icon: "/assets/sections-four/Section_8.png",
        },
        {
          _id: 9,
          is_section_enable: true,
          icon: "/assets/sections-four/Section_9.png",
        },
        {
          _id: 10,
          is_section_enable: true,
          icon: "/assets/sections-four/Section_10.png",
        },
        {
          _id: 11,
          is_section_enable: true,
          icon: "/assets/sections-four/Section_11.png",
        },
        {
          _id: 12,
          is_section_enable: true,
          icon: "/assets/sections-four/Section_12.png",
        },
      ],
      header: {
        is_section_enable: true,
        primary_color: "046A38",
        secondary_color: "01190D",
        contact: {
          email_id: "sales@bestatlaundry.com",
          contact_number: "+442086388690",
        },
        nav: {
          bg_color: "ffffff",
          menu_font_color: "2e3639",
          menu_font_color_active: "1b9db3",
          menu_font_color_hover: "f07f1b",
          cart_section: {
            is_enable: true,
            bg_color: "ffffff",
            cart_icon_color: "ffffff",
            cart_icon_bg_color: "#f07f1b",
            cart_label_section: {
              label: "items : ",
              color: "#6b7385",
            },
            cart_value_color: "000000",
          },
        },
        btn_group: {
          btn1_text: "Login / Register",
          btn1_bg_color: "046A38",
          btn1_color: "ffffff",
          btn1_border_color: "046A38",
          btn1_is_enable: true,
          btn2_text: "Quick Order",
          btn2_color: "ffffff",
          btn2_bg_color: "000",
          btn2_border_color: "#192335",
          btn2_is_enable: true,
        },
      },
      section_1: {
        is_section_enable: true,
        banner_type: "image",
        banner: "/assets/home_page_single_search.jpg",
        banner_two: "/assets/img/home/heroimg.png",
        sub_heading_top: "24/7 Dry Cleaning & Laundry Service",
        title: "One Solution for all your Washing Needs",
        paragraph: "Select your time & location for the service",
        btn_group: {
          btn1: {
            text: "Order now",
            bg_color: "#046A38",
            color: "ffffff",
            placeholder: "Enter Postcode",
          },
        },
      },
      section_2: {
        is_section_enable: true,
        title: "Trust the Experts",
        paragraph:
          "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC",
        first_card_image: "/assets/img/home/trustimg1.jpg",
        image_title: "Why 1000+ customers trust Us?",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "191919",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "/assets/icons/priorityicon1.png",
              collection_title: "Top Quality",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 2,
              icon: "/assets/icons/priorityicon4.png",
              collection_title: "Professionalism",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 3,
              icon: "/assets/icons/priorityicon5.png",
              collection_title: "Convenience",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 4,
              icon: "/assets/icons/priorityicon6.png",
              collection_title: "Cleanliness",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
          ],
        },
      },
      section_3: {
        is_section_enable: true,
        title:
          "5 star Rated by customers in the UK in categories of dry cleaning",
        banner: "/assets/img/home/review-bg.jpg",
        h2color: "ffffff",
      },
      section_4: {
        is_section_enable: true,
        banner: "/assets/home/trustimg2.jpg",
        title: "About We",
        paragraph_one:
          "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock,",
        paragraph_two:
          "A Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.",
        option_one: "Free same day collection",
        option_two: "Dedicated 24/7 support",
        option_three: "Standard wash for just £14",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "191919",
        btn_group: {
          btn1: {
            text: "Know More",
            bg_color: "#046A38",
            color: "ffffff",
            is_enable: true,
          },
        },
      },
      section_5: {
        is_section_enable: true,
        title: "How We Works",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "191919",
        paragraph:
          "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "/assets/home/howwe1.jpg",
              card_title: "Online Order",
              card_paragraph:
                "Use our friendly and easy access website or app to place your laundry order. choose a suitable pickup location and time.",
            },
            {
              _id: 2,
              icon: "/assets/home/howwe2.jpg",
              card_title: "Transport",
              card_paragraph:
                "Our registered driver will pick up your laundry at your doorstep and transport the laundry safely to one of our many trusted dry cleaning facilities.",
            },
            {
              _id: 3,
              icon: "/assets/home/howwe3.jpg",
              card_title: "Dry Cleaning",
              card_paragraph:
                "Our registered driver will pick up your laundry at your doorstep and transport the laundry safely to one of our many trusted dry cleaning facilities.",
            },
            {
              _id: 4,
              icon: "/assets/home/howwe4.jpg",
              card_title: "Door Delivery",
              card_paragraph:
                "Dry and clean clothes were carefully bagged and delivered to your doorstep.",
            },
          ],
        },
      },
      section_6: {
        is_section_enable: true,
        title: "service for Business & Personal",
        paragraph:
          "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC",
        first_card_image: "/assets/home/trustimg3.png",
        sub_title: "For Business",
        sub_title_two: "For Personal",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "046a38",
        card_section: {
          collection: [
            {
              _id: 1,
              collection_list: "Restaurants",
            },
            {
              _id: 2,
              collection_list: "Spa",
            },
            {
              _id: 3,
              collection_list: "Hotels",
            },
            {
              _id: 4,
              collection_list: "Gym",
            },
            {
              _id: 5,
              collection_list: "Factory",
            },
            {
              _id: 6,
              collection_list: "Malls",
            },
            {
              _id: 7,
              collection_list: "Public sectors",
            },
            {
              _id: 8,
              collection_list: "Hospitals",
            },
          ],
        },
        card_section_two: {
          collection: [
            {
              _id: 1,
              collection_list: "Home Stay",
            },
            {
              _id: 2,
              collection_list: "Local Living",
            },
            {
              _id: 3,
              collection_list: "Hostel",
            },
            {
              _id: 4,
              collection_list: "Cottage",
            },
            {
              _id: 5,
              collection_list: "PG Stay",
            },
          ],
        },
      },
      section_7: {
        is_section_enable: true,
        title: "Our Product Category",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "ffffff",
        paragraph:
          "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "/assets/img/laundry.png",
              card_title: "Laundry",
            },
            {
              _id: 2,
              icon: "/assets/img/alterations.png",
              card_title: "Alterations",
            },
            {
              _id: 3,
              icon: "/assets/img/dry cleaning.png",
              card_title: "Dry Cleaning",
            },
            {
              _id: 4,
              icon: "/assets/img/ironing.png",
              card_title: "Ironing",
            },
            {
              _id: 5,
              icon: "/assets/img/repairs.png",
              card_title: "Repairs",
            },
          ],
        },
      },
      section_8: {
        is_section_enable: true,
        part_one: {
          title: "How we Prioritize",
          sub_title: "Step we follow for Health & Safety Precaution",
          section_image: "/assets/home/trustimg2.jpg",
          paragraph:
            "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old",
          card_section: {
            collection: [
              {
                _id: 1,
                collection_title: "Contactless deliveries",
                collection_paragraph:
                  "For our customers safety, we enabled the feature to allow customers to conduct contactless pick up & deliveries.",
              },
              {
                _id: 2,
                collection_title: "Instant updates",
                collection_paragraph:
                  "We’ll keep you posted throughout the process with texts/emails when driver is on their way and order has been cleaned.",
              },
              {
                _id: 3,
                collection_title: "Monitoring the situation",
                collection_paragraph:
                  "We’re keeping up to date with all developments from government to ensure the safety of our customers and staff.",
              },
            ],
          },
        },
        part_two: {
          bg_color: "046A38",
          text_color: "ffffff",
          title: "We use Eco-friendly Laundry Detergent Sheets.",
          paragraph:
            "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin",
          card_section: {
            collection: [
              {
                _id: 1,
                collection_title: "Vegan",
                collection_paragraph:
                  "Our vegan-friendly laundry detergent is free from any animal product.",
              },
              {
                _id: 2,
                collection_title: "Cruelty Free",
                collection_paragraph:
                  "We never test on animals – so our Laundry Leaves will always be cruelty-free.",
              },
              {
                _id: 3,
                collection_title: "Eco-Friendly",
                collection_paragraph:
                  "Free from any harmful chemicals or pollutants and are devoid of harmful toxins.",
              },
            ],
          },
        },
      },
      section_9: {
        is_section_enable: true,
        title: "Frequently Asked Question",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "6d7a80",
        description:
          " Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC",
        card_image: "/assets/home/trustimg4.jpg",
      },
      section_10: {
        is_section_enable: true,
        banner: "howwe1",
        title: "Client Testimonials",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "6d7a80",
        paragraph:
          "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC",
        review_card: [
          {
            _id: 1,
            reviewer_pic: "/assets/home/testimonialuser1.jpg",
            reviewer_name: "Ariyan Rusov",
            rating: "5",
            review_highlight: "Finibus mauris. Aliquam consectetur",
            review:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
          {
            _id: 2,
            reviewer_pic: "/assets/home/testimonialuser2.jpg",
            reviewer_name: "Darren Valdez",
            rating: "4",
            review_highlight: "Finibus mauris. Aliquam consectetur",
            review:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
          {
            _id: 3,
            reviewer_pic: "/assets/home/testimonialuser3.jpg",
            reviewer_name: "Elinor Dunn",
            rating: "5",
            review_highlight: "Finibus mauris. Aliquam consectetur",
            review:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
        ],
      },
      section_11: {
        is_section_enable: true,
        title: "Just a Click Away",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "6d7a80",
        paragraph:
          "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC",
        check_list: [
          {
            _id: 1,
            icons: "/assets/icons/priorityicon14.png",
            title: "Cashless payments",
          },
          {
            _id: 2,
            icons: "/assets/icons/priorityicon15.png",
            title: "Delivery in less then 24 hours",
          },
          {
            _id: 3,
            icons: "/assets/icons/priorityicon16.png",
            title: "Standard wash for just £14",
          },
          {
            _id: 4,
            icons: "/assets/icons/priorityicon17.png",
            title: "In-app live chat support",
          },
        ],
        banner: "/assets/home/just_clickaway.png",
      },
      section_12: {
        is_section_enable: true,
        title: "Blogs & Events",
        h2color: "0E1017",
        h3color: "0E1017",
        paracolor: "ffffff",
        description:
          " Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC",
      },
      footer: {
        bg_color: "046A38",
        section_heading_color: "ffffff",
        section_paragraph_color: "c2c2c2",
        text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        mbl_number: "+442086388690",
        email_val: "sales@bestatlaundry.com",
        address_val: "81 Randall Drive, Hornchurch - RM126TA",
        social_media: {
          facebook: {
            is_enable: true,
            facebook_link: "facebook.com",
          },
          instagram: {
            is_enable: true,
            instagram_link: "instagram.com",
          },
          whatsapp: {
            is_enable: true,
            whatsapp_link: "whatsapp.com",
          },
          linkedin: {
            is_enable: true,
            linkedin_link: "linkedin.com",
          },
          youtube: {
            is_enable: true,
            youtube_link: "youtube.com",
          },
          twitter: {
            is_enable: true,
            twitter_link: "twitter.com",
          },
        },
      },
    },
  },
  theme_5: {
    home: {
      header: {
        is_section_enable: true,
        primary_color: "2fa0ea",
        secondary_color: "efc10b",
        nav: {
          bg_color: "2fa0ea",
          menu_font_color: "ffffff",
          menu_font_color_active: "efc10b",
          menu_font_color_hover: "efc10b",
          cart_section: {
            is_enable: true,
            bg_color: "ffffff",
            cart_icon_color: "ffffff",
            cart_icon_bg_color: "#f07f1b",
            cart_label_section: {
              label: "items : ",
              color: "#6b7385",
            },
            cart_value_color: "ffffff",
          },
        },
        btn_group: {
          btn1_text: "Log in",
          btn1_bg_color: "efc10b",
          btn1_color: "ffffff",
          btn1_border_color: "efc10b",
          btn1_is_enable: true,
          btn2_text: "Sign up",
          btn2_bg_color: "efc10b",
          btn2_color: "ffffff",
          btn2_border_color: "efc10b",
          btn2_is_enable: true,
          btn3_text: "Quick Order",
          btn3_color: "ffffff",
          btn3_bg_color: "efc10b",
          btn3_border_color: "efc10b",
          btn3_is_enable: true,
        },
      },
      sections: [
        {
          _id: 1,
          is_section_enable: true,
          icon: "/assets/section-five/section_1.png",
        },
        {
          _id: 2,
          is_section_enable: true,
          icon: "/assets/section-five/section_2.png",
        },
        {
          _id: 3,
          is_section_enable: true,
          icon: "/assets/section-five/section_3.png",
        },
        {
          _id: 4,
          is_section_enable: true,
          icon: "/assets/section-five/section_4.png",
        },
        {
          _id: 5,
          is_section_enable: true,
          icon: "/assets/section-five/section_5.png",
        },
        {
          _id: 6,
          is_section_enable: true,
          icon: "/assets/section-five/section_6.png",
        },
        {
          _id: 7,
          is_section_enable: true,
          icon: "/assets/section-five/section_7.png",
        },
        {
          _id: 8,
          is_section_enable: true,
          icon: "/assets/section-five/section_8.png",
        },
        {
          _id: 9,
          is_section_enable: true,
          icon: "/assets/section-five/self_service_section.png",
        },
        {
          _id: 10,
          is_section_enable: true,
          icon: "/assets/section-five/our_service_section.png",
        },
      ],
      section_1: {
        is_section_enable: true,
        banner_type: "image",
        banner: "/assets/home_page_single_search.jpg",
        banner_two: "/assets/img/home/heroimg.png",
        title: "A Professional Dry Cleaning & Laundry Service in the UK",
        paragraph:
          " We offer laundry services to both homes and businesses in the UK Our highly trained staff are always on hand to assist you with all your laundry needs",
        btn_group: {
          btn1: {
            text: "Search",
            bg_color: "2fa0ea",
            color: "ffffff",
            placeholder: "Enter Postcode",
          },
        },
      },
      section_self_services: {
        is_section_enable: true,
        title: "Self Services",
        service_title: [
          {
            _id: 1,
            service_list: "Small Washer - 7 kilo load is £6",
          },
          {
            _id: 2,
            service_list: "Medium Washer - 12 Kilo load is £8",
          },
          {
            _id: 3,
            service_list: "Larger Washer - 18 Kilo load is £9.50",
          },
          {
            _id: 4,
            service_list: "Medium Drier - Max 10 Kilo load is £1 for 8 minutes",
          },
          {
            _id: 5,
            service_list: "Larger Drier - Max 20 Kilo load is £1 for 6 minutes",
          },
        ],
      },
      section_our_services: {
        is_section_enable: true,
        title: "Our Services",
        btn_group: {
          btn1: {
            text: "See Full Price List",
            bg_color: "2fa0ea",
            color: "ffffff",
          },
        },
        service_section: {
          services: [
            {
              _id: 1,
              service_title: "DRY CLEANING",
              service_image: "/assets/img/services/service-icon-1.png",
              isEnabled: true,
              service_description:
                "BestAtLaundry provides quality service with reasonable prices to all.",
              service_text: "FROM £5.50",
            },
            {
              _id: 2,
              service_title: "ALTERATION AND REPAIRS",
              service_image: "/assets/img/services/service-icon-2.png",
              isEnabled: true,
              service_description: "Fitting service available in store",
              service_text: "FROM £4.00",
            },
            {
              _id: 3,
              service_title: "SERVICE WASH",
              service_image: "/assets/img/services/service-icon-3.png",
              isEnabled: true,
              service_description: "Washed, tumble dried and folded",
              service_text: "FROM £4.00",
            },
            {
              _id: 4,
              service_title: "IRONING",
              service_image: "/assets/img/services/service-icon-4.png",
              isEnabled: true,
              service_description:
                "Items are delivered on hangers or folded if requested",
              service_text: "FROM £3.00",
            },
            {
              _id: 5,
              service_title: "BEDDING",
              service_image: "/assets/img/services/service-icon-5.png",
              isEnabled: true,
              service_description:
                "Bed Sets, Duvets, Pillows, Blankets, Mattress Covers/Protectors",
              service_text: "FROM £5.50",
            },
            {
              _id: 6,
              service_title: "HOUSEHOLD TEXTILES",
              service_image: "/assets/img/services/service-icon-6.png",
              isEnabled: true,
              service_description:
                "Curtains, Sofa & Cushion covers, Rugs and more. The symbol needs to be a curtain",
              service_text: "FROM £3.00",
            },
            {
              _id: 7,
              service_title: "SPECIALIST ITEMS",
              service_image: "/assets/img/services/service-icon-7.png",
              isEnabled: true,
              service_description: "including Leather, Fur and Suede",
              service_text: "FROM £3.00",
            },
            {
              _id: 8,
              service_title: "TRAINER CLEANING",
              service_image: "/assets/img/services/service-icon-8.png",
              isEnabled: true,
              service_description: "Trainers, Plimsoles and High Tops",
              service_text: "FROM £5.50",
            },
            {
              _id: 9,
              service_title: "WEDDING DRESSES",
              service_image: "/assets/img/services/service-icon-9.png",
              isEnabled: true,
              service_description:
                "Specialist cleaned, restored and presented to keep forever",
              service_text: "FROM £3.00",
            },
          ],
        },
      },
      section_4: {
        is_section_enable: true,
        banner: "/assets/img/offer/offer-vector-bg.png",
        offer_tag: "/assets/img/offer/offer-tag.png",
        picture: "/assets/img/offer/offer-wash-img.png",
        paragraph_one:
          "* Offer applied only to Registered Users (On Selected Shops)",
      },
      section_5: {
        is_section_enable: true,
        banner: "/assets/img/wash-fold-bg.jpg",
        banner_two: "/assets/img/home/heroimg.png",
        title: "WASH & FOLD",
        h2color: "ffffff",
        paracolor: "2e3639",
        wash_title: [
          {
            _id: 1,
            wash_list: "Washed under 30 degrees",
          },
          {
            _id: 2,
            wash_list: "Dried at medium heat",
          },
          {
            _id: 3,
            wash_list:
              "Customer’s responsibility to make sure all items are washable",
          },
          {
            _id: 4,
            wash_list:
              "Towels and beddings are excluded and will be charged separately.",
          },
        ],
      },
      section_6: {
        is_section_enable: true,
        title: "ABOUT BestAtLaundry",
        sub_heading:
          "Professional dry cleaning & laundry services in London, Providing a traditional service with a modern approach.",
        section_image: "/assets/img/about-section/about-img.png",
        background_image_color: "efc10b",
        paragraph:
          "With over 50 years of collective experience in the laundry and dry cleaning industry, we endeavour to provide the very best service and advice based on our knowledge and expertise in the Dry Cleaning and Laundry industry.",
        h2color: "ffffff",
        h3color: "ffffff",
        paracolor: "ffffff",
        card_section: {
          collection: [
            {
              _id: 1,
              collection_title: "Cost Effective",
              collection_image: "/assets/img/about-section/about-icon-01.png",
              isEnabled: true,
              collection_paragraph:
                "BestAtLaundry provides quality service with reasonable prices to all.",
            },
            {
              _id: 2,
              collection_title: "Ease to Use",
              collection_image: "/assets/img/about-section/about-icon-02.png",
              isEnabled: true,
              collection_paragraph:
                "User friendly app and website, Book orders with 1 step.",
            },
            {
              _id: 3,
              collection_title: "Fast Delivery",
              collection_image: "/assets/img/about-section/about-icon-03.png",
              isEnabled: true,
              collection_paragraph:
                "Our team will collect and deliver within 48 hours.",
            },
            {
              _id: 4,
              collection_title: "Quality of Service",
              collection_image: "/assets/img/about-section/about-icon-04.png",
              isEnabled: true,
              collection_paragraph:
                "Our promise is to perfectly dry clean, wash & fold and return fresh clothes back to you.",
            },
          ],
        },
      },
      section_7: {
        is_section_enable: true,
        title: "Ease to Made Laundry",
        paragraph1:
          "Here at BestAtLaundry we understand how hectic and busy life can be. We are here to help you spend less time doing the laundry so you have more time doing the things you love. Making things easier and simpler is our goal.",
        banner: "/assets/img/easy-to-img.png",
        paragraph2:
          "Just 4 simple steps to clean laundry Book online or through app",
        paragraph3:
          "Can’t get more simpler then that Our team at BestAtLaundry will wash, dry clean, iron, fold, pack your clothes neatly and deliver to you within 48 hours!!! ",
        paragraph4:
          "BestAtLaundry provides an extensive and ever-growing list of services. Among the most popular services are shoe repairs and alterations.",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "2e3639",
        card_section: [
          {
            _id: 1,
            text: "Choose a convenient date and time slot",
          },
          {
            _id: 2,
            text: "Our driver will collect from your doorstep",
          },
          {
            _id: 3,
            text: "We will do wonders with your dirty laundry",
          },
          {
            _id: 4,
            text: "We will deliver your order at your chosen timeslot.",
          },
        ],
      },
      section_8: {
        is_section_enable: true,
        banner: "/assets/home/iPhone13.png",
        bg_color: "#FBF2FF",
        placeholder: "Eg:-  +4407816545718",
        banner_two: "/assets/img/home/heroimg.png",
        title: "Download the app",
        paragraph:
          "With our award-winning app, your laundry and dry cleaning needs are just a tap away",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "2e3639",
        mobile_link_section: {
          is_enable: true,
          android_link:
            "https://play.google.com/store/apps/details?id=co.in.dreamguys.bestatlaundry",
          ios_link:
            "https://itunes.apple.com/us/app/best-laundry/id1434880614?ls=1&mt=8",
        },
      },
      footer: {
        custome_banner_design: {
          is_enable: true,
        },
        bg_color: "2fa0ea",
        section_heading_color: "ffffff",
        section_paragraph_color: "c2c2c2",
        site_title_en: "© All rights reserved. ",
        footer_section: {
          we_are_here_section: {
            is_enable: true,
            text: "WE ARE HERE FOR YOU..",
          },
          needhelp_section: {
            is_enable: true,
            text: "NEED HELP?",
          },
          policy_section: {
            is_enable: true,
            text: "OUR POLICY",
          },
          quickconnect_section: {
            is_enable: true,
            text: "QUICK CONNECT",
          },
          callnow_for_Services_section: {
            is_enable: true,
            address: {
              label: "address",
              value: "204 High Road, Woodford Green, IG8 9EF",
            },
            mbl_no: {
              is_enable: true,
              label: "Phone",
              value: "+442086388690",
            },
            email: {
              is_enable: true,
              label: "Email",
              value: "sales@bestatlaundry.com",
            },
            mbl_no_two: {
              is_enable: true,
              label: "Phone",
              value: "+442086388690",
            },
            email_two: {
              is_enable: true,
              label: "Email",
              value: "sales@bestatlaundry.com",
            },
          },
          social_media: {
            facebook: {
              is_enable: true,
              facebook_link: "https://www.facebook.com/bestatservicess",
            },
            instagram: {
              is_enable: true,
              instagram_link: "https://www.instagram.com/bestatservices",
            },
            whatsapp: {
              is_enable: false,
              whatsapp_link: "whatsapp.com",
            },
            linkedin: {
              is_enable: false,
              linkedin_link: "linkedin.com",
            },
            youtube: {
              is_enable: false,
              youtube_link: "youtube.com",
            },
            twitter: {
              is_enable: false,
              twitter_link: "twitter.com",
            },
          },
          mobile_link_section: {
            is_enable: true,
            android_link:
              "https://play.google.com/store/apps/details?id=co.in.dreamguys.bestatlaundry",
            ios_link:
              "https://itunes.apple.com/us/app/best-laundry/id1434880614?ls=1&mt=8",
          },
        },
      },
    },
  },
  theme_10: {
    home: {
      sections: [
        {
          _id: 1,
          is_section_enable: true,
          icon: "/assets/section/section1.jpg",
        },
        {
          _id: 3,
          is_section_enable: true,
          icon: "/assets/section/section3.jpg",
        },
        {
          _id: 4,
          is_section_enable: true,
          icon: "/assets/section/section4.jpg",
        },
        {
          _id: 5,
          is_section_enable: true,
          icon: "/assets/section/section5.jpg",
        },
        {
          _id: 6,
          is_section_enable: true,
          icon: "/assets/section/section6.jpg",
        },
        {
          _id: 7,
          is_section_enable: true,
          icon: "/assets/section/section7.jpg",
        },
        {
          _id: 8,
          is_section_enable: true,
          icon: "/assets/section/section8.jpg",
        },
        {
          _id: 9,
          is_section_enable: true,
          icon: "/assets/section/section9.jpg",
        },
        {
          _id: 10,
          is_section_enable: true,
          icon: "/assets/section/section10.jpg",
        },
        {
          _id: 11,
          is_section_enable: true,
          icon: "/assets/section/section11.jpg",
        },
        {
          _id: 12,
          is_section_enable: true,
          icon: "/assets/section/section12.jpg",
        },
        {
          _id: 13,
          is_section_enable: true,
          icon: "/assets/section/section13.jpg",
        },
        {
          _id: 15,
          is_section_enable: true,
          icon: "/assets/section/section15.jpg",
        },
      ],
      header: {
        is_section_enable: true,
        primary_color: "1B9DB3",
        secondary_color: "F07F1B",
        nav: {
          bg_color: "ffffff",
          menu_font_color: "2e3639",
          menu_font_color_active: "1b9db3",
          menu_font_color_hover: "f07f1b",
          cart_section: {
            is_enable: true,
            bg_color: "ffffff",
            cart_icon_color: "ffffff",
            cart_icon_bg_color: "#f07f1b",
            cart_label_section: {
              label: "items : ",
              color: "#6b7385",
            },
            cart_value_color: "000000",
          },
        },
        btn_group: {
          btn1: {
            text: "Login / Register",
            bg_color: "ffffff",
            color: "#1b9db3",
            border_color: "#1b9db3",
            btn1_is_enable: true,
          },
          btn2: {
            text: "Quick Order",
            color: "ffffff",
            bg_color: "000",
            border_color: "#192335",
            btn2_is_enable: true,
          },
        },
      },
      section_1: {
        is_section_enable: true,
        banner_type: "image",
        banner: "/assets/home_page_single_search.jpg",
        banner_two: "/assets/home/heroimg.png",
        sub_heading_top: "24/7 Dry Cleaning & Laundry Service",
        title: "One Solution for all your Washing Needs",
        paragraph:
          "Bestatlaundry is synonymous with quality, reliability, and trust. We provide fast dry cleaning and laundry services in and around London. Advance online technology and modern process and equipment utilization means affordable cost to all our customers.",
        btn_group: {
          btn1: {
            text: "Book now",
            bg_color: "#1b9db3",
            color: "ffffff",
            placeholder: "Enter Postalcode",
          },
        },
        mobile_link_section: {
          is_enable: true,
          mob_title: "Just A Click Away",
          android_link: "#",
          ios_link: "#",
        },
      },
      section_2: {
        is_section_enable: true,
        sub_heading_top: "Book A Service",
        title: "Select Your Time & Location For The Service",
        h2color: "2e3639",
        h3color: "2e3639",
        paracolor: "6d7a80",
        btn_group: {
          btn1: {
            text: "order now",
            bg_color: "#1b9db3",
            color: "ffffff",
          },
        },
      },
      section_3: {
        is_section_enable: true,
        sub_heading_top: "Dry Cleaning & Laundry",
        title: "Trust The Expert On Laundry Services",
        h2color: "ffffff",
        h3color: "ffffff",
        paracolor: "ffffff",
        paragraph:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "/assets/icons/priorityicon1.png",
              collection_title: "Top Quality",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 2,
              icon: "/assets/icons/priorityicon2.png",
              collection_title: "Best Service",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 3,
              icon: "/assets/icons/priorityicon3.png",
              collection_title: "Value",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 4,
              icon: "/assets/icons/priorityicon4.png",
              collection_title: "Professionalism",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 5,
              icon: "/assets/icons/priorityicon5.png",
              collection_title: "Convenience",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
            {
              _id: 6,
              icon: "/assets/icons/priorityicon6.png",
              collection_title: "Cleanliness",
              collection_paragraph:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
            },
          ],
          btn_group: {
            btn1: {
              text: "More About Us",
              bg_color: "192335",
              color: "ffffff",
            },
          },
        },
      },
      section_4: {
        is_section_enable: true,
        title:
          "Bestatlaundry is Ranked #1 by customers in the UK in categories of dry cleaning",
        h2color: "ffffff",
      },
      section_5: {
        is_section_enable: true,
        banner: [
          {
            banner: "/assets/home/howwe1.jpg",
          },
        ],
        title: "We collect, clean, & deliver your laundry & dry cleaning.",
        paragraph:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
        h2color: "ffffff",
        paracolor: "ffffff",
        check_list: [
          {
            _id: 1,
            list: "Free same day collection",
          },
          {
            _id: 2,
            list: "24h turnaround time",
          },
          {
            _id: 3,
            list: "Dedicated 24/7 support",
          },
          {
            _id: 4,
            list: "Standard wash for just £14",
          },
          {
            _id: 5,
            list: "Wash & Fold for items that don't need pressing",
          },
          {
            _id: 6,
            list: "Free collection and delivery",
          },
        ],
        btn_group: {
          btn1: {
            text: "Schedule a Collection Now",
            bg_color: "#192335",
            color: "ffffff",
            is_enable: true,
          },
          btn2: {
            text: "Request a Pickup",
            bg_color: "#1b9db3",
            color: "ffffff",
            is_enable: true,
          },
        },
      },
      section_6: {
        is_section_enable: true,
        sub_heading_top: "Know More On",
        title: "How We Works",
        paragraph:
          "We collect, clean and deliver your clothes within 24-48 hrs.",
        h2color: "ffffff",
        h2subcolor: "ffffff",
        h3color: "ffffff",
        paracolor: "ffffff",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "/assets/home/howwe1.jpg",
              card_title: "Online Order",
              card_paragraph:
                "Use our friendly and easy access website or app to place your laundry order. choose a suitable pickup location and time.",
            },
            {
              _id: 2,
              icon: "/assets/home/howwe2.jpg",
              card_title: "Transport",
              card_paragraph:
                "Our registered driver will pick up your laundry at your doorstep and transport the laundry safely to one of our many trusted dry cleaning facilities.",
            },
            {
              _id: 3,
              icon: "/assets/home/howwe3.jpg",
              card_title: "Dry Cleaning",
              card_paragraph:
                "Our registered driver will pick up your laundry at your doorstep and transport the laundry safely to one of our many trusted dry cleaning facilities.",
            },
            {
              _id: 4,
              icon: "/assets/home/howwe4.jpg",
              card_title: "Door Delivery",
              card_paragraph:
                "Dry and clean clothes were carefully bagged and delivered to your doorstep.",
            },
          ],
          btn_group: {
            paragraph: "Lorem Ipsum is simply dummy text of the",
            btn1: {
              text: "Book Online Now",
              bg_color: "#192335",
              color: "#ffffff",
            },
          },
        },
      },
      section_7: {
        is_section_enable: true,
        title: "On Demand Laundry, Dry Cleaning And Ironing Categories",
        paragraph:
          "We provide commercial laundry, shoe repair, clothing alteration, tailoring and wedding dress fitting services in London, Essex, Kent, Westminster, Chelsea, Dartford, Croydon, Enfield, Basildon, South On Sea, Bromley, Mayfair, Romford and other areas in London.",
        h2color: "ffffff",
        h3color: "ffffff",
        paracolor: "ffffff",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "/assets/img/laundry.png",
              card_title: "Laundry",
            },
            {
              _id: 2,
              icon: "/assets/img/alterations.png",
              card_title: "Alterations",
            },
            {
              _id: 3,
              icon: "/assets/img/dry cleaning.png",
              card_title: "Dry Cleaning",
            },
            {
              _id: 4,
              icon: "/assets/img/ironing.png",
              card_title: "Ironing",
            },
            {
              _id: 5,
              icon: "/assets/img/repairs.png",
              card_title: "Repairs",
            },
          ],
        },
        btn_group: {
          btn_paragraph: "Lorem Ipsum is simply dummy text of the",
          btn1: {
            text: " Request a Pickup",
            bg_color: "192335",
            color: "fff",
          },
        },
      },
      section_8: {
        is_section_enable: true,
        banner: "howwe1",
        title: "About Us",
        section_image: "/assets/home/trustimg2.jpg",
        paragraph:
          "Bestatlaundry is synonymous with quality, reliability, and trust. We provide fast dry cleaning and laundry services in and around London. Advance online technology and modern process and equipment utilization means affordable cost to all our customers.",
        h2color: "ffffff",
        h3color: "ffffff",
        paracolor: "ffffff",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "James please use React import aliase",
              collection_title: "Free Pick up and Delivery",
              collection_image: "/assets/icons/priorityicon7.png",
              isEnabled: true,
              collection_paragraph:
                "We offer a convenient way to have laundry picked up and delivered for free.",
            },
            {
              _id: 2,
              icon: "James please use React import aliase",
              collection_title: "High Quality of Services",
              collection_image: "/assets/icons/priorityicon8.png",
              isEnabled: true,
              collection_paragraph:
                "Our laundry team perfectly cleans, iron, fold, pack, and deliver to you on time.",
            },
            {
              _id: 3,
              icon: "James please use React import aliase",
              collection_title: "Affordable Cost",
              collection_image: "/assets/icons/priorityicon9.png",
              isEnabled: true,
              collection_paragraph:
                "We offer affordable prices when compared to the current market.",
            },
          ],
        },
        btn_group: {
          btn1_text: "Schedule a Collection Now",
          btn1_bg_color: "192335",
          btn1_color: "ffffff",
          btn2_text: "Request a Pickup",
          btn2_bg_color: "1b9db3",
          btn2_color: "ffffff",
        },
      },
      section_9: {
        is_section_enable: true,
        section_bg_color: "#1b9db3",
        sub_heading_top: "Our Promising Services",
        title: "On Demand Laundry, Dry Cleaning And Ironing Service",
        paragraph:
          "We collect, clean and deliver your clothes within 24-48 hrs.",
        h2color: "ffffff",
        h3color: "ffffff",
        paracolor: "ffffff",
        card_section: {
          collection: [
            {
              _id: 1,
              icon: "/assets/home/priorityimg1.jpg",
              collection_title: "Laundry",
              collection_paragraph:
                "A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.",
            },
            {
              _id: 2,
              icon: "/assets/home/priorityimg2.jpg",
              collection_title: "Dry Cleaning",
              collection_paragraph:
                "A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.",
            },
            {
              _id: 3,
              icon: "/assets/home/priorityimg3.jpg",
              collection_title: "Alteration & Repair",
              collection_paragraph:
                "A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.",
            },
            {
              _id: 14,
              icon: "/assets/home/priorityimg1.jpg",
              collection_title: "Laundry",
              collection_paragraph:
                "A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.",
            },
          ],
          count_section: [
            {
              _id: 1,
              icon: "/assets/icons/priorityicon1.png",
              text: "Laundry Clothes",
              count: "1639+",
            },
            {
              _id: 2,
              icon: "/assets/icons/priorityicon2.png",
              text: "Steam Ironing",
              count: "24359+",
            },
            {
              _id: 3,
              icon: "/assets/icons/priorityicon3.png",
              text: "Dry Cleaning",
              count: "4793+",
            },
            {
              _id: 4,
              icon: "/assets/icons/priorityicon4.png",
              text: "Cleaning programs",
              count: "25+",
            },
          ],
        },
      },
      section_10: {
        is_section_enable: true,
        banner: "/assets/home/trustimg3.png",
        sub_heading_top: "Your Health & Safety Is Our Priority",
        title: "Our Values",
        mainparagraph:
          "online laundry & dry cleaning companies who simply just own the technology and farm the cleaning to other providers with little to no process system checks.",
        h2color: "ffffff",
        h3color: "ffffff",
        paracolor: "ffffff",
        cardcolor: "ffffff",
        list_Section: [
          {
            _id: 1,
            text: "Contactless deliveries",
            paragraph:
              "For our customers safety, we enabled the feature to allow customers to conduct contactless pick up & deliveries.",
          },
          {
            _id: 2,
            text: "Instant updates",
            paragraph:
              "We’ll keep you posted throughout the process with texts/emails when driver is on their way and order has been cleaned.",
          },
          {
            _id: 3,
            text: "Monitoring the situation",
            paragraph:
              "We’re keeping up to date with all developments from government to ensure the safety of our customers and staff.",
          },
        ],
        card_section_title: "We use Eco-friendly Laundry Detergent Sheets.",
        card_section: [
          {
            _id: 1,
            card_bg_color: "192335",
            card_text: "Vegan",
            card_paragraph:
              "Our vegan-friendly laundry detergent is free from any animal product.",
          },
          {
            _id: 2,
            card_bg_color: "f07f1b",
            card_text: "Cruelty Free",
            card_paragraph:
              "We never test on animals – so our Laundry Leaves will always be cruelty-free.",
          },
          {
            _id: 3,
            card_bg_color: "1bb333",
            card_text: "Eco-Friendly",
            card_paragraph:
              "Free from any harmful chemicals or pollutants and are devoid of harmful toxins.",
          },
        ],
      },
      section_11: {
        is_section_enable: true,
        banner: [
          {
            banner: "/assets/home/howwe1.jpg",
          },
        ],
        card_section: {
          collection: [
            {
              _id: 1,
              collection_title: "Free Pick up and Delivery",
              isEnabled: true,
              collection_paragraph:
                "We offer a convenient way to have laundry picked up and delivered for free.",
            },
            {
              _id: 2,
              collection_title: "High Quality of Services",
              isEnabled: true,
              collection_paragraph:
                "Our laundry team perfectly cleans, iron, fold, pack, and deliver to you on time.",
            },
            {
              _id: 3,
              collection_title: "Affordable Cost",
              isEnabled: true,
              collection_paragraph:
                "We offer affordable prices when compared to the current market.",
            },
          ],
        },
        sub_heading_top: "Ask Your Question",
        title: "Frequently Asked Questions",
        paragraph:
          "online laundry & dry cleaning companies who simply just own the technology and farm the cleaning to other providers with little to no process system checks.",
        h2color: "ffffff",
        paracolor: "ffffff",
      },
      section_12: {
        is_section_enable: true,
        banner: "howwe1",
        sub_heading_top: "What Our Client Says",
        title: "A Trusted Laundry And Dry Cleaning Company",
        paragraph: "Read what our customers say about us",
        review_bottom_paragraph:
          "More than 5,000+ reviews s on TrustPilot, Google, Google Play & App Store",
        h2color: "ffffff",
        h3color: "ffffff",
        paracolor: "ffffff",
        review_card: [
          {
            _id: 1,
            reviewer_pic: "/assets/home/testimonialuser1.jpg",
            reviewer_name: "Ariyan Rusov",
            rating: "5",
            review_highlight: "Finibus mauris. Aliquam consectetur",
            review:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
          {
            _id: 2,
            reviewer_pic: "/assets/home/testimonialuser2.jpg",
            reviewer_name: "Darren Valdez",
            rating: "4",
            review_highlight: "Finibus mauris. Aliquam consectetur",
            review:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
          {
            _id: 3,
            reviewer_pic: "/assets/home/testimonialuser3.jpg",
            reviewer_name: "Elinor Dunn",
            rating: "5",
            review_highlight: "Finibus mauris. Aliquam consectetur",
            review:
              "My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.",
          },
        ],
        btn_group: {
          btn1: {
            text: "Book Online Now",
            bg_color: "#192335",
            color: "#ffffff",
            is_enable: true,
          },
        },
      },
      section_13: {
        is_section_enable: true,
        banner: "/assets/home/iPhone11.png",
        title: "Just A Click Away",
        paragraph: "Download Our Best Active Mobile App",
        h2color: "ffffff",
        h3color: "ffffff",
        paracolor: "ffffff",
        check_list: [
          {
            _id: 1,
            icons: "/assets/icons/priorityicon14.png",
            title: "Cashless payments",
          },
          {
            _id: 2,
            icons: "/assets/icons/priorityicon15.png",
            title: "Delivery in less then 24 hours",
          },
          {
            _id: 3,
            icons: "/assets/icons/priorityicon16.png",
            title: "Standard wash for just £14",
          },
          {
            _id: 4,
            icons: "/assets/icons/priorityicon17.png",
            title: "In-app live chat support",
          },
        ],
        mobile_link_section: {
          is_enable: true,
          android_link:
            "https://play.google.com/store/apps/details?id=co.in.dreamguys.bestatlaundry",
          ios_link:
            "https://itunes.apple.com/us/app/best-laundry/id1434880614?ls=1&mt=8",
        },
      },
      section_14: {
        is_section_enable: true,
        section_bg_color: "#1b9db3",
        title:
          "Subscribe to our newsletter for updates, exclusive promotions and our latest content!",
        btn_group: {
          btn1: {
            text: "Subscribe",
            bg_color: "#192335",
            color: "ffffff",
          },
        },
      },
      section_15: {
        is_section_enable: true,
        sub_heading_top: "Our Latest",
        title: "News & Events",
        paragraph:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",
        h2color: "ffffff",
        h3color: "ffffff",
        paracolor: "ffffff",
        btn_group: {
          btn1: {
            text: "More News & Events",
            bg_color: "#192335",
            color: "ffffff",
          },
        },
      },
      footer: {
        custome_banner_design: {
          is_enable: true,
        },
        bg_color: "151e2e",
        section_heading_color: "ffffff",
        section_paragraph_color: "c2c2c2",
        footer_section: {
          about_section: {
            is_enable: true,
            text: "Ready to take laundry off your to-do list? Bestatlaundry services is a local laundry pickup and delivery service that you can order directly from your smart phone.",
          },
          service_section: {
            is_enable: true,
          },
          quicklink_section: {
            is_enable: true,
          },
          callnow_for_Services_section: {
            is_enable: true,
            mbl_no: {
              is_enable: true,
              label: "+442086388690",
              value: "tel:+442086388690",
            },
            email: {
              label: "Email Us",
              value: "sales@bestatlaundry.com",
            },
            mbl_no_two: {
              is_enable: true,
              label: "+442086388690",
              value: "tel:+442086388690",
            },
            email_two: {
              label: "Email Us",
              value: "sales@bestatlaundry.com",
            },
            address: {
              text: "81 Randall Drive, Hornchurch - RM126TA",
            },
          },
          social_media: {
            facebook: {
              is_enable: true,
              facebook_link: "facebook.com",
            },
            instagram: {
              is_enable: true,
              instagram_link: "instagram.com",
            },
            whatsapp: {
              is_enable: true,
              whatsapp_link: "whatsapp.com",
            },
            linkedin: {
              is_enable: true,
              linkedin_link: "linkedin.com",
            },
            youtube: {
              is_enable: true,
              youtube_link: "youtube.com",
            },
            twitter: {
              is_enable: true,
              twitter_link: "twitter.com",
            },
          },
        },
      },
    },
  },
  theme_6: {
    home: {
      section_4: {
        title: "test ",
        sub_heading_top: "sub title test",
        title_color: "4a5da1",
        sub_title_color: "4e7319",
        banner:
          "https://api.laundryup.co.uk/storage/compress_images/68875f0bd99e9.png",
        cards: [
          {
            image:
              "/static/media/delivery-01.10614ca51a23535447f185fae42bd033.svg",
            title: "Delivery Days",
            sub_heading_top: "Every Tuesday & Friday",
          },
          {
            image:
              "/static/media/delivery-02.848f683885e5d4b69af306242a5fcc5e.svg",
            title: "Time Slots",
            sub_heading_top: "10:00 AM – 5:00 PM",
          },
          {
            title: "Location",
            sub_heading_top: "Warner Bros Studios",
            image:
              "/static/media/delivery-03.f3a408d0a3731b1dcc5018ced9613003.svg",
          },
        ],
      },
      section_2: {
        banner:
          "https://api.laundryup.co.uk/storage/compress_images/688755a04188a.png",
        title: "How It Works",
        sub_heading_top:
          "A simple 4-step process designed exclusively for Warner Brotherss",
        cards: [
          {
            title: "Step 1",
            description:
              "Select “Quick” for simple bundles or “Itemized” to choose each item.",
            title_color: "783434",
            sub_title_color: "852020",
            image: "/static/media/work-01.cb42638110c6067fcaddec768ab0a1b4.svg",
          },
          {
            image: "/static/media/work-02.64873abeabffe3155815020c5c198888.svg",
            description:
              "Pickup & Drop location to : WB Studios, Leavesden Park, Watford.",
            title: "Step 2",
            title_color: "ab9090",
            sub_title_color: "377282",
          },
          {
            image: "/static/media/work-03.26c4e8f59f27313476f24e526d96e3ce.svg",
            title: "Step 3",
            description: "Choose a time slot – Tuesdays or Fridays only.",
          },
          {
            title: "Step 4",
            description: "Pay a fixed £5 booking fee to confirm your order.",
            title_color: "b33d3d",
            image: "/static/media/work-04.0508ac4e38b6bf6236776a155c8691d6.svg",
          },
        ],
      },
      section_1: {
        title: "Professional Laundry Service at WBD",
        sub_heading_top: "Twice a week. Hassle-free. Trusted at the Studio",
        banner:
          "https://api.laundryup.co.uk/storage/compress_images/68874f1b835dd.jpeg",
        bg_color: "dee061",
        color: "ffffff",
        text: "Book Now",
      },
      section_3: {
        title: "Which Order Type Suits You?",
        sub_heading_top:
          "Whether you're in a hurry or need custom care, we've got you covered",
        title_color: "4d3f3f",
        sub_title_color: "827a7a",
        cards: [
          {
            title: "Quick Order",
            description:
              "Flat-rate price per load Good for daily wear like shirts & trousers Same WB Studio pickup No item selection required Faster checkout",
            image:
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARoAAACaCAMAAABBqnfkAAAC+lBMVEUAAAB1t8+s3+ir2+d2uM5rqMR1uc+s3ul1uM51uM6fz991t8+s3+lRan12uc+t3+l3udBQan1QaXt1tsut3uh2uc+DwdWq3ehIXnKr3eh2us+o2OdQaXw+VGB4u9Cs3uhRa3yt3+lRa36s3+lQaHx2uc8sOkVQan0pOEKf1eJ9vdOs3ujo0SdItZ3v//sqOULvW1F2uc/Un1VRan1NNCaoZS3/uYD3qic5j3z////wzZyKp7n/1z2l2uWg1uHWQjhZdIKRy9vr6JHRviqLyNnu9Mjt7qtGrZbaRzt7vNLRdztjfIuW0N6DnrJdvan/90xCTD5xcji5qy6v2d2n1UuqlxODwtWz1dN0jqE6Tlepc0KhlzFpg5Xq4nQ0RU/d9/F8l6rp10Hq1TNZPCutz9JsipdMYm1xx7Xvr0GJhTSVu8DJxpxBpI5EWGOVjzObTSOx5NiEmJjyc0VaST7cyCigVieHur1SuaP0gjzzkjLu+eCgyc89mITbwHDq3Vz2oiqbytTy1886kn/9sHupkHJwdG/mb1JlaDp8fTdmQiqVQx/v/O6H0cB7oKrHqKmrsaFUbHV/f3Dep23qZ1//d1ipf1fwZkzlUkc0QkPfTEFZXzt2SiiHxNfB07+zzL6qvrTMuI7OpWPya17TlU7RhkihazehXyv68e7L6+h8ysLby7m8wK6nrpTr5YPkunX+xmBmWU3rVkyQVyzs657rxI/zvXn/wHH2iG7XyGLyf16Kd0nFsyr6xcHRl5ZVboF0xHbffHW/iV3q3Fzhh1Wze0XgYzOtoi+CTC3v4Nqf3M6O0sqRq6lzlZ+qoos/n4lHmYnYiIXmvIHFnXzKr3pnmXnZpl/AzVpxeFbs2k9NVT1OVjynQzfofDK+nh/u+uGAwNS8v8RlwbH2nJfRp4tmamLkt1ekq0f15zzt8Lnpt6h8tpW8p5D6m25RhmrNZl2e0FT/0Et9ZxtjuZN8iYertnDV1kX1vjzZuyvDd3SiaE2McCnanyRytrJERz9kz2BSAAAAK3RSTlMAIL9BgBDC73BAEGB/ZN+fn+WFUd+vMGAgcO8goDWPz7+Pz69I732vW99wLOjUIQAAEiVJREFUeNrs2N2KozAUB/CTGlOtRYW2lnagZVjmYsjVeYAEBG8KXufpfLe+yibR0bGNrLNdWKn9QUtBr/7kfDQwH8ERUx9e7mWoUXjphBEBg6IWg+FHG3ixiQSgbVDbgUZindGrtAhqH2CkOhBS/7BxzV2Ghg/GpunCO9ROMHd+jIgMLELBClALYfYIi49hPxpgLH7Vk0XSfjRRBDNHQmjQsBcNg0Y206qiiHEGlp+CH+ziI8aMEqAbqLGZzvAMNQa1YHfELyyFWjTX9ThCA6wwxlYXR1rvgPPjoxavEy3FG6l9YYfazDryyjsk52V5QSWLXHCJd04A0S6kM1v8vPViyTtC6YjuBbuZLTYrL1nyWwpdDiuYEUcumkCnki/2bzALq/WSO5XopLiWePD0vAW/IfOSWxU6XQQ3Pulzj6j9wnlWFDeu6GajyRGRPW1duSvpgpoU2gXdyvbh5/opw7HBDEVT5Jormv5Dybd7eDYmGLe8bSdD0cj2Na5tn+zg7Ld8UK4qMdyGNdG8VghurWGiiA8/5Z35GCU6Xfmt8zQPDrUXJ+QUPTCuhwytfHe2k9xyYsQNABt9mf2W8NHUcD11JllU9EQAAmTERrN5oPs6ibxCB1VMP5tNfZtETCbZLnio+/aJQpVcVtLVba76aS5kpcoJZxM2F0uR+ZC27TzeZOw6dy25ljv/JQhVz/C+BKYjCihoQRj6Op4/VdUq4SNJrHcWRzZKcKNAreATzgZI4NMjaozYa8mYPNpkumgcE/yiuNZFM81smuYSHbFBdUzDK4635T9w/TaiK1FWFzRULgrRldxFTLQXx4gZADliK324yXTKXH79shFJWUjbZKp2epWTnVMMkYb6u/Phm9ZMyX0tvfO/p76i4FYT2bAD/HdEB0NS/I7aocVGNJmRRF4UsovGUoUtqmET2YspfseiiN5Fs3cGM34ZLvrRyGZ+D1u+wb+xyvaH9+TXopa8HzxvBaP1T82HGeQpGdF9x5FoiF40qh1Ng86/ybV7lzbCOA7gj7E2sZJaTdREW6tNKeLv4IRcCRIICelSVDARqiEigiSYiIKNSItI7SDaweJURJfSoa7BpYO2CEIddHC1o9Shc/+BPs9zSR6Tu5wXnti8+BkcDXx5fi/P3d3jT6W222BU/d8O+7Wnso5eEpTRqHdf7mjwCym5jujVwQeaGnljsYIWo6Ot45rX0i0WU0t2QWkGw1NQHjkQVlDa7PxvfbRpvu0xyV03O5p6VGeqYcHwG3wxCISP7YAe2pm1GVs5njzq5WjLf0mQRzjTXtN65748wu/ZH0MxeViH0cWKdOAuf2tjreblmyFZteNFUBk+Px8tI/34gtHPmqewalCDpTXz+UsLjequifxG8XnIMqwfdzD6GdqUE7ETlxD5DrFd7jOWevIT3UYoB6ggHQ7g4shNBwdSQ5/U1Fvo7aDX1FkeuRQaTTHq35C173TK07qBfrBZazf4yHwtE0i/1qJNDANemDtQRv2DXvIdFZmxg2SIlAmkmx2KzGg1EFZrO50cPhoKufiVCd2bjAFuzEsaDW47ZZMKpbeYrHBzPHQ3fYVX1bKCdGkzws3zlNehAX2TCW4jJLOZmzGz2Wxpfkb09PQ8wmw2261NBhBh7nJSkcnZCVFpIhSajUajm16vNxKJnG5sbCwuLsZXVlagqpETkwrGOzQg6sdiC2ViO12EKoKTaUon4xW5hbzVc5QQ6nLKUmdmKxCLxdYDgbXt7e3z4eHhgsNxQ5VAZqds3E3bzPqCkGtbLMwGVAd2aMZFLCAo+bdETXNBLBwOx2JrcvuJQ1VAqU7zw007zb6gIiZqGb6a4rmIRaEqIKfM646K2IKg5lzU4BeuWKC9yQPVIOfU+AU1/oCYV0zIMidildSJPfOryUQyIWHJ1RNgaDSUmw6ooKDJnxFMyT1mQRE7hUoRT0pZEvOQkTO7wwInv4hFoELMSwqJJUhBD9PRjNFpI3BaEDEvVIa/EqPMBjU7ZZOTrHPwIJN+EyoCPjMa2bCVb2yI7TU8yIiahYqQkNQlgWDRROg2vCZwortzCCrBiZTPPBDoadZF4ZfAi855UDc6szw9PX10dPhxFErvt5RPAghkc8oG3LN0teW1LmIroDTy+dLlcr193UedlTycJSm/OGCoLnsdFjiwnS8OCjMuEsynvozvwI+/Ce9IalYBQ6gpHc0mW4c5hNXX4WUX9qZP9uVgd/f9xdkIlNKqRjRTgKGcdXhf4BRUfS5xeTWZi91+4s8hdzb80exJ1AeVikLoSdY6/LPo67DyzOBkqIND4MRfUF8l6lhlRqGcdThc5HWY9Zl3fSkH/WnfStlvlqSdnZ3j53tTuH6m8F9Fs0H/Yx3+18x59DYRhGF4L/wMzhwGmwiytmmxZMk4AgRCxkIERRAHQSCIqmA6hISOCAECBAShQ0LoBEITvYveRRG9d9GLxBTH36xnd2eDY+0+lyDlEPRo5p13x9+6gKgZ2bBo2iYozpiH7CNf5VgutD5Qk6Y6DIdTRpzHbYE1C208w2epHCxzTu/kcljh6nArTR3eMi5I6IQJEHIxkwh5mKisDouLBvYT8NieIxzUACSIl6tqZpzxWI1RHY66pYzDJPTtCgTy9OvwCkgaQjFWsvFM8cGDxcVnDmYsRLaxXU3aUeXcxjpP1DRPqOnN1+HoOHdjmRPVrcMTYT8RXj3euyYDOLTZriP8lsqzc9SZN+QHHFFK0pMC1OE8vIk6YYKEB5g5UjdRqMNipzHmiD2BU67ynKjZvgH/2ABHlKJYujgHYZhJhFzMloBG3xb9OuyFqDHCjoWjVXO0+IRKOA1PmIoiXJynyCmow5waeHjasaSyMpvg99Mf5B+2nOHnV9HuubG45tWTJ69USk4+5LACdRguzpuqDotqllT6sZHKJdMZ7+/+eP/+/Q9bzHTc1JajmK2dN9CHiZoW8PllWupwAT6f7u88nZ9/+i5hX0mJp4EFmVnINogaIEfF1JRzfViBJ4V+cHGeEq2S6vDE3/c/ZWZ++sS61AIPR8koZA+imqMqpngWd52lcHW4H50HaPI6vDIS+ZR5v0P0VyamwqPhKbIRQc3VVVQNI0tR4OK8fdM8KdxJqsP9I5FffTp06LCN/F26aIARyDZENSeKVU7NYKqGr8PLmv52OBKJdMDsWZ0vqLFrqELcUTnYzAlezQhFU4fTczv8PPKdqvE875G5WqsG2cl5zsxG9cmZEyqvplxJrsNLU1YzKFnNlwY1FTOfexykprwM1JypWZWjvZuYpkjrcOq3w1WR+0QNOazrb9bxZnYjOxmRfyah5okKZRjUpL0OhyOR+9+wGkLdzbq6VbW1r1+//vz5dW0hspOszFk1cTNXh8G1jaCm6erwgUQdhrCJDO3w0UO52fOwC7B39n57Zn45lrOx5ufs2SpDG8NpmSPpgji+YDVfmZq6nho1WchOBrNylz8bozKWw1CAghHmSFJEuDivikQOfK2narY6SU1iimT27GEqY0M+K+3l5PFSuDhPw+1wBJ9RX7cSNRO1apCdgJtZTA1zk/90BPtgFwNzJE1dh2FHteywrb5OUNMN2c34aaPosilSG1hfhRgKpvFzJNGo2W9nkOFhxFOG6/A2z82JdEN9ADUDkQMYP3jw+J8bVOACoiiYxs2RTNpFb42DL3PzzJ4UNCkSvk/UeG7We+o0aroih1CmcqwfnYUQVdOYOZJogL8h7pRnXoeBeqrGU1/v6dmz52dXnBhyCB3Pc2Kuh1yuasTUWJ8jmUQXjIkcqMOjEc9togZTV38Th41DzqeEmOpY4p54//V4CnYkaqzPkexyC4y7bVyHgRX0EYrAh41D3mXIirlC69mCoWIYj0CNfI4k+tKtR0Csw8JYdS6oWdQ6vmxiVcgRdI3h/8z1/fv3l5OdBFQrGItzJEG3PgFZHe61MGNkQVxNyaJF+1Z/wGKqbZ9YS6wZAxSMfI4EdpPcjViH52VgFr+Nq8Fu5mU5JGXAjA6K1ToccBuzRazD/Js/RzIo+0rohlq01yHrhfLIJVEjr8N5bjOOmdbhhRlx9lI1T5BzqHZJ1AhzJCLjzAcB8kzq8IoxiY8u17z17F3koEWTFZOpkdfhgNucoHEd7kVGSBJTsWv27UXOYaBLokZ+cZ7nlrHFqA73KoDxGsrCyw+RQzjnkqgR50gEOlmcrRHrcJiZIYsGmIecQUymRn5xnueW00m/Dk/UGyE5ghxBtUumRn5xDotGfkpBHYaxWDx35MBVk+WSqpHPkViaXQuKdZhtJ3Ega2EYOYCYXI10jiTXbYljYh1eRc2IXEb2U+2Sq5HOkby0pualdqx6AFs0YzP0sP+QynJZUCObI4m6LRLVPCn0ZklDzyYHbqmBVtTI5khyraoJJNfhZ8mLxjlvQ3U08BHSqJHNkXSyPDecVId7GQ/F2jRKLW97U4eAGnkdlp9PmzZBEHN1uDDeaJyYNgZP3EN8E3g1kjkSad/r2w1fpQ53Y3Zp3jIcPTGhxnmHVDd9NRN8vpBWTTOxDluPGvpXYn35HdWH1uFnVI0zd5RB0vh8sGwUaR3eJTEz3EU5y3YU/6Ub7BHBnh1V1l+Swgb7CSOoMazDQYma+Cl4jp1R/Fi1sZr0Py3kqKVmcqqN9hNmCKiRzJGMkySNi0HDJsiPVT81VpP+Z8xSVc0pQ4ZcMlEzFdRI5kjc5sx1Ubppj++lVA09vO0JmyoVY7hwRvsMjm4fIQRqTC/Ob0tDmDLXTbnN1eG/ump2JP6V1ovQ/hUq4YK+nEtwDmnwUYaAGtM5kkmyEGb01V72LSMdAF4R46hMc9iE+5fVllasVykGu2o0Xhkmq2YCqDGdI8m1FMID4UIL6jDcfPJqlqTxWaG2IkfFDIOREF05lyBrhawhgBrTi/MtFkOYEeTHqn8TN4Ka7DSWvoqiomF4+KxomMqTUyUsGgM1Q5iaEKgxmyMJWA9hlsNQh9fqHVGVfsjhNKhh60XjBvIYFo3volkOXwQ1ZnMkAashzIhydfiEXg5n+5ek77XCKnVD0TBMUVGRquUCv2ggT8RlA79U4rQxmiMJWA1hxm2uDldA2PBqKhvRh8O9eq1cuXlzYeGqVdeurV7d+qpEZ2kRXTfYjwokRc4lVl6kzUbBmM6RBKyGMCOXq8PlWEziLgvUZMMRpWtiBaampvDaaqwiibWdZSf+BeoF1oy4q0ZD1OoQolsqBGpM5kgC1kIY1EAdnu+FHcWp8SeOKLYk2Jqgi4KwoB0DhEjV8PQvK62oKC2tLVvZP4zCVbU53MKpRZgQRK3hlhoCakzmSAJWQhgI8F+6UQDNhlfT0PrWthYBNTd01axs/IG+XnNWnfOBGsMtdVFQo1eHA1ZCGNjFj1Wzz+caqeaGiZp1oMY6/XP4XXVdpiZEwgbUCHMk+r1m09nhfXVDGOjEf+lGIXx0yalJHFHH/0PNZpSiG3X/O1BjuKVCoMZ4jiQXkoWEbre+hiEs1uEVXu89CJtGqlmQkhrRDXAL1OgylYWNIqvDoAbfNIMbIYRBDdTh8V7vyeSwqTRQA8jUpO7mnbmaEGs2iiK5OIer4fhNc7VBCIMa+NKNAu/JyQ3NZs2aplDzBjWBm1ugRpeLPh+oMZ4jiXJqGGf1QxjUwFuGE70nx+IcHlnAvhGg5O3bvf5U1HQGNam42Q9qjLZUiKqRzJEkJu/PumAHCSEMavjvoCv0nsRh840NDTO4rJmur2Y3U7NVV81VlIIb6aqBLTWEqJFdnAe52GXENumHsHg7vMJ7z599rwObwmfsw4e3HWpQuEKjxmXKRaZGMkfSSfOBUyKKIYQFNfClG2HvWL//pEZNSbYNahilfAy7zGEbSjJHAsUG3AwUQhgeFBgvaB1GBZP9/mys5qMHlo1FNVf0ynDnoygFLqgMWuokUDWSOZJjfOeLuRjnIIT11ERfdKd1GOEc9vu/YTcebtlI1FxJhxpww1J4giU1kjmSqHALQRgohjBcSrzo3r37DDpHUojDxj8WXt4g7GtQs/g/1KxDKVGFH6jWk/100ZIa2RwJ5DAcUwlDOjM20e4E2vnQChI2kMOUkgxLananQw0avf4WfGogVSObI9nl1ncDIQzMIUuGQjvflLDXmx0PG2Bvgxt9NVsN1axLXQ3qBk+XEhRpHYaw4UswhLCGIBbDeE7rMCogYVNAwwZY8/9qOqNU+XPJopp/E2iTwk7ONJIAAAAASUVORK5CYII=",
          },
          {
            title: "Itemized Order",
            description: "9e3939",
            flat_rate: "pay per item",
            title_color: "946363",
            sub_title_color: "945d5d",
            flat_color: "7d3636",
            flat_rate_bg_color: "995353",
            image:
              "data:image/png;base64,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",
          },
        ],
      },
      section_5: {
        title: "Professional Laundry Service at WBD",
        sub_heading_top: "Twice a week. Hassle-free. Trusted at the Studio",
        banner:
          "https://api.laundryup.co.uk/storage/compress_images/688761396bdb0.jpeg",
        bg_color: "dee061",
        color: "ffffff",
        text: "Book Now",
      },
      section_6: {
        title: "Ready to Schedule Your Laundry?",
        sub_heading_top: "Confirm in under a minute. Fixed booking fee applies",
        title_color: "050533",
        sub_title_color: "a17575",
        button_text: "Book now ",
        btn_bg_color: "2332d1",
        btn_color: "fffcfc",
      },
    },
  },
};
